<template>
  <v-app>
    <v-container class="pa-0 pa-sm-3 pa-md-3 mt-n5">
      <v-alert v-if="alert" dense outlined type="error"  color="green" style="position: fixed; top: 8 ; right: 0 ; z-index: 3">
        <strong>{{ msg }}</strong>
        <template v-slot:append>
          <v-icon class="ml-4" @click="alert= false" color="green"
          style="cursor:pointer;">mdi-close</v-icon>
        </template>
      </v-alert>
        <v-snackbar
      v-model="snackbar"
      timeout="5000"
      color="orange"
    >
      {{ textsnac }}

     
    </v-snackbar>
      <div class="pt-16 pa-6 pa-sm-4 pa-md-4 d-none d-md-block">

        <v-col cols="12" class="pl-7">
          <v-card class="mt-7 elevation-0">

            <v-toolbar class="mb-3 toolbar-contantd px-md-3" elevation="0" color="white">
              <v-list-item class="pl-0 pl-md-1 ">
                <v-list-item-content>
                  <v-list-item-title class="text-start"
                    style="color: #000000;font-size: 20px;font-weight:559;line-height:24px;letter-spacing:-1px">
                    Tax P&L </v-list-item-title>
                  <v-list-item-subtitle class="text-start pt-1"
                    style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Tax P&L Data
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-spacer></v-spacer>
            <v-menu :disabled="segloader || disabletabs || loader"
        :loading="segloader || disabletabs || loader"
        v-if="downloadarray.length > 0" bottom offset-y>

  <template v-slot:activator="{ on, attrs }">
    <v-btn class="elevation-0 rounded-pill mt-n2 mr-2" v-bind="attrs" v-on="on">
      <v-icon size="20">mdi mdi-download</v-icon>
    </v-btn>
  </template>

  <v-list>
   <v-list-item v-for="(item, i) in itemsdwl" :key="i" @click="() => { }">
                    <v-list-item-title @click="valdwl(item.title)">{{ item.title }}</v-list-item-title>
                  </v-list-item>
  </v-list>
</v-menu>
<v-dialog v-model="showDownloadDialog"   max-width="400px"   persistent >
  <v-card class="rounded-xl">
    <v-card-title>Select Date Range</v-card-title>
    <v-card-text>
      <v-menu
        ref="fromMenu"
        v-model="fromMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
          class="textbox  elevation-0"
          solo
          flat
            v-model="fromDate"
            background-color="#F1F3F8"
            label="From Date"
            prepend-inner-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="fromDate" @input="fromMenu = false"></v-date-picker>
      </v-menu>

      <v-menu
        ref="toMenu"
        v-model="toMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
          class="textbox elevation-0"
          solo
          flat
          background-color="#F1F3F8"
            v-model="toDate"
            label="To Date"
            prepend-inner-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="toDate" @input="toMenu = false"></v-date-picker>
      </v-menu>
    </v-card-text >
    <v-card-actions class="pb-5">
      <v-btn  class=" brdr text-none black--text rounded-pill elevation-0 " width="180px" text @click="showDownloadDialog = false">Cancel</v-btn>
      <v-btn class=" text-none white--text rounded-pill elevation-0" :loading="isloading" width="180px" :disabled="!fromDate || !toDate"  color="black" @click="apiexcelcl">Download</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

              <v-select style="width: 200px;overflow: hidden" dense background-color="#F1F3F8"
                :disabled="segloader || disabletabs || loader" :loading="segloader || disabletabs || loader" rounded
                :readonly="disabletabs" @change="gettaxpnl(yearis)" :items="items" v-model="yearis" flat solo
                class="mt-n3 dropdown  elevation-0 rounded-pill pr-5 " label="From" prepend-inner-icon="mdi-calendar"
                hide-details append-icon="mdi-chevron-down"></v-select>


              <!-- <v-select style="width: 160px; overflow: hidden" dense background-color="#F1F3F8" :loading="disabletabs"
                :readonly="disabletabs" rounded @change="gettaxpnl(yearis)" :items="items" v-model="ye|aris" flat solo
                class="mt-n3 dropdown  elevation-0 rounded-pill  pr-4" label="From" prepend-inner-icon="mdi-calendar"
                hide-details append-icon="mdi-chevron-down"></v-select> -->
              <!-- <v-text-field v-model="search" class=" ml-3 mt-4" height="36px" background-color="#F1F3F8"
                style="min-width: 180px; " label="Search " solo rounded flat dense>
                <template v-slot:prepend-inner>
                  <img alt="" class="shrink" :src="require('@/assets/searchicon.svg')" width="20px" height="18px" />
                </template>
              </v-text-field> -->
            </v-toolbar>
            <v-divider></v-divider>
            <div class="display-flex row   d-none d-md-block pa-8">

              <v-row>
                <v-col cols="3">
                  <v-card :disabled="segloader || disabletabs || loader" @click="opendetailstat(newstateq, 0)"
                    class="ml-3 pl-3 py-1 pr-2 elevation-0" height="90px" :style="{
                      borderWidth: tab === 0 ? '2px' : '0.5px',
                      borderStyle: 'solid',
                      borderColor: '#E4E4E4'
                    }">
                    <p class="pt-1 mb-3"
                      style="font-weight:450; font-size:14px; color:#000000; line-height:16px; letter-spacing:-0.4px;">
                      Equity Net  <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon>
                    </p>
                    <v-divider class="mt-2" style="border:solid px #000000" width="30px" color="#000000"></v-divider>
                    <div class="display-flex row pt-6 pl-2">
                      <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                        <p class="mb-0" :style="{
                          color: (
                            (newstateq?.trading || 0) +
                            (newstateq?.delivery_sell || 0) -
                            (newstateq?.delivery_buy || 0) +
                            (segval || 0)
                          ) > 0 ? 'green' : (
                            (newstateq?.trading || 0) +
                            (newstateq?.delivery_sell || 0) -
                            (newstateq?.delivery_buy || 0) +
                            (segval || 0)
                          ) < 0 ? 'red' : 'black',
                        }" style=" font-size:13px; font-weight:469; line-height:12px; letter-spacing:0.9px;">
                          {{
                            (
                              (newstateq?.trading || 0) +
                              (newstateq?.delivery_sell || 0) -
                              (newstateq?.delivery_buy || 0) +
                              (segval || 0)
                            ).toFixed(2)
                          }}
                        </p>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="3">
                  <v-card :disabled="segloader || disabletabs || loader" :style="{
                    borderWidth: tab === 1 ? '2px' : '0.5px',
                    borderStyle: 'solid',
                    borderColor: '#E4E4E4'
                  }" @click="opendetailstat(newstat?.der_total, 1)" class="ml-3 pl-3 py-1 pr-2" outlined height="90px">
                    <p class="pt-1 mb-3"
                      style="font-weight:450; font-size:14px; color:#000000; line-height:16px; letter-spacing:-0.4px;">
                      Derivative Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon>
                    </p>
                    <v-divider class="mt-2" style="border:solid px #000000" width="30px" color="#000000"></v-divider>
                    <div class="display-flex row pt-6 pl-2">
                      <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                        <p class="mb-0" :style="{
                          color:
                            (newstat?.der_total?.der_total_value || 0) > 0 ? 'green' : (
                              (newstat?.der_total?.der_total_value || 0)
                            ) < 0 ? 'red' : 'black',
                        }" style="  font-size:13px; font-weight:469; line-height:12px; letter-spacing:0.9px;">
                          {{
                            newstat?.der_total?.der_total_value?.toFixed(2) || 0
                          }}
                        </p>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="3">
                  <v-card :disabled="segloader || disabletabs || loader" :style="{
                    borderWidth: tab === 2 ? '2px' : '0.5px',
                    borderStyle: 'solid',
                    borderColor: '#E4E4E4'
                  }" @click="opendetailstat(newstat?.com_total, 2)" class="ml-3 pl-3 py-1 pr-2" outlined height="90px">
                    <p class="pt-1 mb-3"
                      style="font-weight:450; font-size:14px; color:#000000; line-height:16px; letter-spacing:-0.4px;">
                      Commodity Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon>
                    </p>
                    <v-divider class="mt-2" style="border:solid px #000000" width="30px" color="#000000"></v-divider>
                    <div class="display-flex row pt-6 pl-2">
                      <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                        <p :style="{
                          color:
                            (newstat?.com_total?.com_total_value || 0) > 0 ? 'green' : (
                              (newstat?.com_total?.com_total_value || 0)
                            ) < 0 ? 'red' : 'black',
                        }" class="mb-0"
                          style="font-size:13px; font-weight:469; line-height:12px; letter-spacing:0.9px;">
                          {{
                            newstat?.com_total?.com_total_value?.toFixed(2) || 0
                          }}
                        </p>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="3">
                  <v-card :disabled="segloader || disabletabs || loader" :style="{
                    borderWidth: tab === 3 ? '2px' : '0.5px',
                    borderStyle: 'solid',
                    borderColor: '#E4E4E4'
                  }" @click="opendetailstat(newstat?.curr_total, 3)" class="ml-3 pl-3 py-1 pr-2" outlined
                    height="90px">
                    <p class="pt-1 mb-3"
                      style="font-weight:450; font-size:14px; color:#000000; line-height:16px; letter-spacing:-0.4px;">
                      Currency Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon>
                    </p>
                    <v-divider class="mt-2" style="border:solid px #000000" width="30px" color="#000000"></v-divider>
                    <div class="display-flex row pt-6 pl-2">
                      <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                        <p :style="{
                          color:
                            (newstat?.curr_total?.curr_total_value || 0) > 0 ? 'green' : (
                              (newstat?.curr_total?.curr_total_value || 0)
                            ) < 0 ? 'red' : 'black',
                        }" class="mb-0"
                          style=" font-size:13px; font-weight:469; line-height:12px; letter-spacing:0.9px;">
                          {{
                            newstat?.curr_total?.curr_total_value?.toFixed(2) || 0
                          }}
                        </p>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>


            </div>

            <div class="mt-2 mt-sm-0 mt-md-0">
              <div class="mb-n4 pa-2">
                <v-row class="pt-0">
                  <v-col lg="8" sm="12" md="12" cols="12">
                    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>

                      <v-tab v-model="tab2" @click="tabdata('Equities')">
                        Equities
                      </v-tab>

                      <v-tab style="cursor: wait;" v-if="disabletabs" disabled>
                        Derivatives
                      </v-tab>

                      <v-tab v-else-if="!disabletabs" v-model="tab3" @click="tabdata('Derivatives')">
                        Derivatives
                      </v-tab>

                      <v-tab :disabled="disabletabs" v-model="tab4" @click="tabdata('Commodity')">
                        Commodity
                      </v-tab>
                      <v-tab :disabled="disabletabs" v-model="tab5" @click="tabdata('Currency')"
                        :class="{ 'red-text': disabletabs }">
                        Currency
                      </v-tab>

                      <!-- <div v-else-if="!disabletabs">
                        <v-tab v-model="tab3" @click="tabdata('Derivatives')">
                          Derivatives
                        </v-tab>
                        <v-tab v-model="tab4" @click="tabdata('Commodity')">
                          Commodity
                        </v-tab>
                        <v-tab v-model="tab5" @click="tabdata('Currency')">
                          Currency
                        </v-tab>
                      </div> -->
                    </v-tabs>
                  </v-col>
                </v-row>
                <!-- {{ loader }} -->

                <!-- {{ dialog }} -->

                <v-tabs-items v-model="tab">

                  <!-- <v-tab-item>
                    <v-data-table :search="search" hide-default-footer :loading="loader" height="495px" mobile-breakpoint
                      fixed-header disable-sort :headers="Overviewheaders" :items="dessertsoriginal"
                      :items-per-page="itemperpage" item-key="NSE_SCRIPCODE"
                      style="border: 1px solid #efeef3; cursor: pointer" class="elevation-0 rounded-lg "
                      @click:row="detailedpop">
                      <template v-slot:[`item.SCRIP_SYMBOL`]="{ item }">
                        <span v-if="item.COMPANY_CODE == 'DERIVATIVES'" class="font-weight-bold">
                          {{ item.SCRIP_SYMBOL }} <v-icon color="#0037B7">mdi
                            mdi-menu-right</v-icon>
                        </span>
                        <span v-else-if="item.COMPANY_CODE == 'CAPITAL'" class="font-weight-bold">

                          <span
                            v-if="item.SCRIP_SYMBOL[0] == 1 || item.SCRIP_SYMBOL[0] == 2 || item.SCRIP_SYMBOL[0] == 3 || item.SCRIP_SYMBOL[0] == 4 || item.SCRIP_SYMBOL[0] == 5 || item.SCRIP_SYMBOL[0] == 6 || item.SCRIP_SYMBOL[0] == 7 || item.SCRIP_SYMBOL[0] == 8 || item.SCRIP_SYMBOL[0] == 9 || item.SCRIP_SYMBOL[0] == 0">{{
                              item.SCRIP_SYMBOL.split(' ').slice(1).join(' ') }}<v-icon color="#0037B7">mdi
                              mdi-menu-right</v-icon></span>

                          <span v-else>{{ item.SCRIP_SYMBOL }}<v-icon color="#0037B7">mdi
                              mdi-menu-right</v-icon></span>
                        </span>
                        <span v-else class="font-weight-bold">

                          {{ item.SCRIP_SYMBOL.split(' ').slice(1).join(' ') }}<v-icon color="#0037B7">mdi
                            mdi-menu-right</v-icon>

                        </span>
                      </template>


                      <template v-slot:[`item.BUY_QUANTITY`]="{ item }">
                        <span class="font-weight-light"> {{ item.BUY_QUANTITY }}</span>
                      </template>
                      <template v-slot:[`item.CLOSING_PRICE`]="{ item }">
                        <span v-if="item.CLOSING_PRICE" class="font-weight-light"> {{
                          item.CLOSING_PRICE }}</span>
                      </template>
                      <template v-slot:[`item.BUY_RATE`]="{ item }">
                        <span class="font-weight-light"> {{ item.BUY_RATE }}</span>
                        <p class="font-weight-light caption mb-0"> {{ item.BUY_AMOUNT }}</p>

                      </template>
                      <template v-slot:[`item.SALE_QUANTITY`]="{ item }">
                        <span class="font-weight-light">
                          {{ item.SALE_QUANTITY }}</span>
                      </template>
                      <template v-slot:[`item.SALE_RATE`]="{ item }">
                        <span class="font-weight-light"> {{ item.SALE_RATE }}</span>
                        <p class="font-weight-light caption mb-0"> {{ item.SALE_AMOUNT }}</p>
                      </template>

                      <template v-slot:[`item.NET_QUANTITY`]="{ item }">
                        <span class="font-weight-light"> {{ item.NET_QUANTITY }}</span>
                      </template>
                      <template v-slot:[`item.NET_RATE`]="{ item }">
                        <span class="font-weight-light"> {{ item.NET_RATE }}</span>
                        <p class="font-weight-light caption mb-0"> {{ item.NET_AMOUNT }}</p>

                      </template>

                    
                      <template v-slot:[`item.NOT_PROFIT`]="{ item }">
                        <span v-if="item.NOT_PROFIT < 0" class="font-weight-light" style="color: red;"> {{
                          item.NOT_PROFIT }}</span>
                        <span v-if="item.NOT_PROFIT > 0" class="font-weight-light" style="color: green;">
                          {{
                            item.NOT_PROFIT }}</span>
                        <span v-if="item.NOT_PROFIT == 0" class="font-weight-light" style="color: black;">
                          {{
                            item.NOT_PROFIT }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-col class="mx-auto pa-15 mt-5">
                          <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                          <p class="font-weight-bold black--text">No data available</p>
                        </v-col>
                      </template>
                      
                    </v-data-table>
                    <v-dialog v-model="dialog" width="70%" class="elevation-0">
                      <v-card class=" elevation-0 pt-3 pb-2" height="100%">
                        <v-btn :ripple="false" dense class="mt-n4" text icon solo absolute top right
                          @click="dialog = false"><v-icon size="18" color="grey">mdi
                            mdi-close</v-icon></v-btn>
                        <v-toolbar class=" mb-1 mt-4 toolbar-contant" elevation="0" color="white">
                          <v-list class="" style="background-color: transparent;">
                            <v-list-item class=" pt-0">
                              <v-list-item-content class=" pt-0">
                                <v-list-item-title class="text-start"
                                  style="color: #000000;font-size: 18px;font-weight:559;line-height:24px;letter-spacing:-1px">
                                  Detailed P & L </v-list-item-title>
                                <v-list-item-subtitle class="text-start pt-1"
                                  style="color: #666666;font-size: 11px;font-weight:469;line-height:14px">{{
                                    scriptname }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-spacer></v-spacer>
                          <v-list class="mr-7 pt-0" style="background-color: transparent;">
                            <v-list-item class="pl-0 pa-0" style="min-height: 0px;">
                              <v-list-item-content class="pl-2 pa-0">
                                <v-list-item-title class="text-start font-weight-medium d-none d-md-block"
                                  style="color: #000000;font-size: 14px;line-height:16px;">
                                  {{ detailedpoparray.length }}
                                  Trades</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-text-field v-model="search1" class="tophundraedmutual mt-4" height="36px"
                            background-color="#F1F3F8" style="width: 2%;" label="Search" solo rounded flat dense>
                            <template v-slot:prepend-inner>
                              <img alt="" class="shrink" :src="require('@/assets/searchicon.svg')" width="20px"
                                height="18px" />
                            </template>
                          </v-text-field>
                        </v-toolbar>
                        <v-divider></v-divider>

                        <div class=" mb-4 mx-4 my-6">
                          <v-data-table :search="search1" dense :sort-by.sync="sortBy" hide-default-footer
                            :loading="loader" height="405px" mobile-breakpoint fixed-header disable-sort
                            :headers="Overviewheaders2" :items="detailedpoparray" :items-per-page="itemperpage1inner"
                            style="" class="elevation-0 rounded-lg">
                            <template v-slot:[`item.SCRIP_NAME`]="{ item }">
                            
                              <span class="font-weight-regular subtitle-2"> {{ item.SCRIP_NAME
                              }}</span>

                            </template>
                            <template v-slot:footer>
                              <v-divider></v-divider>
                              <div class="text-end">

                                <span class="mr-5 mt-4"
                                  style="color: black;font-size: 14px;font-weight:559;line-height:16px;letter-spacing:0px">Total
                                  : <span v-if="finaltotal > 0" style="color: green"> {{
                                    finaltotal.toFixed(2)
                                  }}</span>
                                  <span v-if="finaltotal < 0" style="color: red"> {{
                                    finaltotal.toFixed(2)
                                  }}</span>
                                </span>
                              </div>

                            </template>
                            <template v-slot:[`item.BQTY`]="{ item }">
                              <span class="font-weight-regular subtitle-2"> {{ item.BQTY
                              }}</span>
                            </template>
                            <template v-slot:[`item.BRATE`]="{ item }">
                              <span class="font-weight-regular subtitle-2"> {{
                                (item.BRATE.toFixed(2))
                              }}</span>
                              <p class="font-weight-medium caption mb-0"> {{ (item.BQTY *
                                item.BRATE).toFixed(2) }}</p>
                            </template>
                            <template v-slot:[`item.NRATE`]="{ item }">
                              <span class="font-weight-regular subtitle-2"> {{ item.NRATE
                              }}</span>
                              <p class="font-weight-medium caption mb-0"> {{ item.NETAMT }}
                              </p>
                            </template>


                            <template v-slot:[`item.SRATE`]="{ item }">
                              <span class="font-weight-regular subtitle-2"> {{
                                (item.SRATE).toFixed(2)
                              }}</span>
                              <p class="font-weight-medium caption mb-0"> {{ (item.SQTY *
                                item.SRATE).toFixed(2) }}</p>
                            </template>
                            <template v-slot:[`item.SQTY`]="{ item }">
                              <span class="font-weight-regular subtitle-2"> {{ item.SQTY
                              }}</span>
                            </template>
                            <template v-slot:[`item.TRADE_DATE`]="{ item }">
                              <span class="font-weight-bold subtitle-2"> {{ item.TRADE_DATE
                              }}</span>
                            </template>
                            <template v-slot:[`item.PRO`]="{ item }">
                              <span v-if="item.NETAMT < 0" class="font-weight-regular subtitle-2" style="color: red;">
                                {{ item.NETAMT }}</span>
                              <span v-if="item.NETAMT > 0" class="font-weight-regular subtitle-2" style="color: green;">
                                {{ item.NETAMT }}</span>
                              <span v-if="item.NETAMT == 0" class="font-weight-regular subtitle-2" style="color: black;">
                                {{ item.NETAMT }}</span>
                            </template>
                            <template v-slot:no-data>
                              <v-col class="mx-auto pa-15 mt-5">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                                <p class="font-weight-bold black--text">No data available
                                </p>
                              </v-col>
                            </template>
                           
                          </v-data-table>
                        </div>
                      </v-card>
                    </v-dialog>

                  </v-tab-item> -->

                  <v-tab-item>
                    <v-data-table :headers="dessertHeaders" :items="dessertsexpand" :single-expand="singleExpand"
                      style="border: 1px solid #efeef3; cursor: pointer"
                      class="cust-table elevation-0 rounded-lg cell-height" fixed-header @click:row="toggleExpanded"
                      :loading="eqloader" height="495px" hide-default-footer show-expand :expanded.sync="expanded"
                      item-key="name" disable-sort>

                      <template v-slot:[`item.name`]="{ item }">
                        <span class="overline"> {{ item.name
                          }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-col class="mx-auto pa-15 mx-0 px-0" style="background-color: white ;">
                          <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                          <p class="font-weight-bold black--text">No data available
                          </p>
                        </v-col>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td class="px-0" :colspan="headers.length">
                          <!-- v-if="item.name != 'Assets'" -->
                          <v-data-table :items-per-page="item.val.length" item fixed-header hide-default-footer dense
                            :headers="headersexpandinside" hide-default-header :items="item.val" item-key="name"
                            class="elevation-0">


                            <template v-slot:item="{ item }">
                              <tr class="" style=" position: relative">

                                <td class="" style="width:1200px">
                                  <span class="font-weight-bold body-2"> <span v-if="item.SCRIP_NAMEDATA != ''">{{
                                    item.SCRIP_NAMEDATA }}</span>
                                    <span v-else>{{ item.SCRIP_NAME }}</span>

                                    <v-tooltip color="black" v-if="item.OPQTY > 0 || item.OPQTY < 0" v-model="item.show"
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="blue" class="ml-2" x-small outlined>{{
                                          item.OPQTY }}</v-chip>
                                      </template>
                                      <span>Open Quantity!</span>
                                    </v-tooltip>
                                  </span>

                                </td>


                                <td class=" text-right" style="width: 200px">
                                  <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>

                                <td class=" text-right pl-0" style="width: 200px">
                                  <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </td>

                                <td class="  text-right" style="width: 200px">
                                  <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>
                                <td style="width: 200px" class="pr-0  text-right">
                                  <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>

                                </td>
                                <td class=" text-right pr-2 " style="width: 200px">
                                  <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>


                                </td>
                                <td class=" text-right " style="width: 200px">
                                  <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </td>
                                <td style="width: 200px" class=" pr-0 text-right">
                                  <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{
                                    item.Closing_Price
                                  }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>

                                </td>

                                <td style="width: 250px" class="  text-right">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2"
                                    style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>

                                </td>
                                <td style="width: 80px">

                                </td>

                              </tr>
                            </template>

                            <!-- <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                              <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                            </template>
                            <template v-slot:[`item.NET_QTY`]="{ item }">
                              <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.NET_RATE`]="{ item }">
                              <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                              <br>
                              <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_QTY`]="{ item }">
                              <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_RATE`]="{ item }">
                              <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                              <span v-else class="font-weight-medium caption">0</span>
                            </template>
                            <template v-slot:[`item.SALE_QTY`]="{ item }">
                              <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.SALE_RATE`]="{ item }">
                              <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.Closing_Price`]="{ item }">
                              <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price
                              }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                              <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template>
                            <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                              <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2" style="color: green">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2" style="color: black">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template> -->
                          </v-data-table>
                          <!-- v-else -->
                          <!-- <v-data-table  :headers="dessertHeaders" :items="dessertsexpand"
                                :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer;  "
                                class="elevation-0 rounded-lg pa-4" fixed-header hide-header @click:row="toggleExpanded4"
                                :loading="loader" height="400px" hide-default-footer hide-default-header show-expand
                                :expanded.sync="expandedinner" item-key="name">
                                <template v-slot:[`item.name`]="{ item }">
                                  <span class="font-weight-bold body-1"> {{ item.name }}</span>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                            <td class="px-0" :colspan="headers.length">
                              <v-data-table style="border: 1px solid rgb(233, 233, 233); border-radius: 10px"
                                :items-per-page="item.val.length" height="300px" item fixed-header hide-default-footer dense
                                :headers="headersexpandinside" :items="item.val" item-key="name" class="elevation-0">
                                <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                                </template>
                                <template v-slot:[`item.NET_QTY`]="{ item }">
                                  <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.NET_RATE`]="{ item }">
                                  <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_QTY`]="{ item }">
                                  <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_RATE`]="{ item }">
                                  <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </template>
                                <template v-slot:[`item.SALE_QTY`]="{ item }">
                                  <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.SALE_RATE`]="{ item }">
                                  <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.Closing_Price`]="{ item }">
                                  <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                                  <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                                <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                              </v-data-table>

                            </td>
                          </template>
                        </v-data-table> -->
                        </td>
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item>


                    <v-data-table :headers="dessertHeaders" :items="dessertsexpandderivative"
                      :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer"
                      class="cust-table elevation-0 rounded-lg cell-height" fixed-header @click:row="toggleExpanded1"
                      :loading="eqloader" height="495px" hide-default-footer show-expand :expanded.sync="expandedder"
                      item-key="name" disable-sort>

                      <template v-slot:[`item.name`]="{ item }">
                        <span class="overline"> {{ item.name
                          }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-col class="mx-auto pa-15 mx-0 px-0 " style="background-color: white ;">
                          <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                          <p class="font-weight-bold black--text">No data available
                          </p>
                        </v-col>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td class="px-0" :colspan="headers.length">
                          <!-- v-if="item.name != 'Assets'" -->
                          <v-data-table :items-per-page="item.val.length" item fixed-header hide-default-footer dense
                            :headers="headersexpandinside" hide-default-header :items="item.val" item-key="name"
                            class="elevation-0">


                            <template v-slot:item="{ item }">
                              <tr class="" style=" position: relative">

                                <td class="" style="width:800px">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_SYMBOL }}

                                    <v-tooltip color="black" v-if="item.OPQTY > 0 || item.OPQTY < 0" v-model="item.show"
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="blue" class="ml-2" x-small outlined>{{
                                          item.OPQTY }}</v-chip>
                                      </template>
                                      <span>Open Quantity!</span>
                                    </v-tooltip>

                                  </span>

                                </td>

                                <td class=" text-right" style="width: 200px">
                                  <span v-if="item.BUYQTY" class="font-weight-medium body-2"> {{ item.BUYQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>

                                <td class=" text-right pr-4" style="width: 200px">
                                  <span v-if="item.BUYRATE" class="font-weight-medium body-2"> {{ item.BUYRATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUYAMT" class="font-weight-medium caption"> {{ item.BUYAMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </td>

                                <td class="pl-0  text-right" style="width: 200px">
                                  <span v-if="item.SALEQTY" class="font-weight-medium body-2"> {{ item.SALEQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>
                                <td style="width: 200px" class="pl-0 text-right">
                                  <span v-if="item.SALERATE" class="font-weight-medium body-2"> {{ item.SALERATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALEAMT" class="font-weight-medium caption"> {{ item.SALEAMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>

                                </td>
                                <td class=" text-right" style="width: 200px">
                                  <span v-if="item.NETQTY" class="font-weight-medium body-2"> {{ item.NETQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>


                                </td>
                                <td class=" text-right " style="width: 200px">
                                  <span v-if="item.NETRATE" class="font-weight-medium body-2"> {{ item.NETRATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NETAMT" class="font-weight-medium caption"> {{ item.NETAMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </td>
                                <td style="width: 200px" class=" pr-0 text-right">
                                  <span v-if="item.CL_PRICE" class="font-weight-medium body-2"> {{ item.CL_PRICE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>

                                </td>

                                <td style="width: 250px" class="  text-right">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2"
                                    style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>

                                </td>
                                <td style="width: 80px">

                                </td>

                              </tr>
                            </template>

                            <!-- <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                              <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                            </template>
                            <template v-slot:[`item.NET_QTY`]="{ item }">
                              <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.NET_RATE`]="{ item }">
                              <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                              <br>
                              <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_QTY`]="{ item }">
                              <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_RATE`]="{ item }">
                              <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                              <span v-else class="font-weight-medium caption">0</span>
                            </template>
                            <template v-slot:[`item.SALE_QTY`]="{ item }">
                              <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.SALE_RATE`]="{ item }">
                              <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.Closing_Price`]="{ item }">
                              <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price
                              }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                              <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template>
                            <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                              <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2" style="color: green">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2" style="color: black">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template> -->
                          </v-data-table>
                          <!-- v-else -->
                          <!-- <v-data-table  :headers="dessertHeaders" :items="dessertsexpand"
                                :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer;  "
                                class="elevation-0 rounded-lg pa-4" fixed-header hide-header @click:row="toggleExpanded4"
                                :loading="loader" height="400px" hide-default-footer hide-default-header show-expand
                                :expanded.sync="expandedinner" item-key="name">
                                <template v-slot:[`item.name`]="{ item }">
                                  <span class="font-weight-bold body-1"> {{ item.name }}</span>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                            <td class="px-0" :colspan="headers.length">
                              <v-data-table style="border: 1px solid rgb(233, 233, 233); border-radius: 10px"
                                :items-per-page="item.val.length" height="300px" item fixed-header hide-default-footer dense
                                :headers="headersexpandinside" :items="item.val" item-key="name" class="elevation-0">
                                <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                                </template>
                                <template v-slot:[`item.NET_QTY`]="{ item }">
                                  <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.NET_RATE`]="{ item }">
                                  <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_QTY`]="{ item }">
                                  <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_RATE`]="{ item }">
                                  <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </template>
                                <template v-slot:[`item.SALE_QTY`]="{ item }">
                                  <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.SALE_RATE`]="{ item }">
                                  <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.Closing_Price`]="{ item }">
                                  <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                                  <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                                <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                              </v-data-table>

                            </td>
                          </template>
                        </v-data-table> -->
                        </td>
                      </template>
                    </v-data-table>
                  </v-tab-item>


                  <v-tab-item>
                    <v-data-table :headers="dessertHeaders" :items="dessertsexpandcommodity"
                      :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer"
                      class="cust-table elevation-0 rounded-lg cell-height" fixed-header @click:row="toggleExpanded2"
                      :loading="eqloader" height="495px" hide-default-footer show-expand :expanded.sync="expandedcom"
                      item-key="name" disable-sort>

                      <template v-slot:[`item.name`]="{ item }">
                        <span class="overline"> {{ item.name
                          }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-col class="mx-auto pa-15 mx-0 px-0" style="background-color: white ;">
                          <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                          <p class="font-weight-bold black--text">No data available
                          </p>
                        </v-col>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td class="px-0" :colspan="headers.length">
                          <!-- v-if="item.name != 'Assets'" -->
                          <v-data-table :items-per-page="item.val.length" item fixed-header hide-default-footer dense
                            :headers="headersexpandinsidecom" hide-default-header :items="item.val" item-key="name"
                            class="elevation-0">


                            <template v-slot:item="{ item }">
                              <tr class="" style="position: relative">

                                <td class="" style="width:700px">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_SYMBOL }}

                                    <v-tooltip color="black" v-if="item.OPQTY > 0 || item.OPQTY < 0" v-model="item.show"
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="blue" class="ml-2" x-small outlined>{{
                                          item.OPQTY }}</v-chip>
                                      </template>
                                      <span>Open Quantity!</span>
                                    </v-tooltip>
                                  </span>

                                </td>


                                <td class=" text-right" style="width: 160px">
                                  <span v-if="item.BUYQTY" class="font-weight-medium body-2"> {{ item.BUYQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>

                                <td class=" text-right pl-0" style="width: 160px">
                                  <span v-if="item.BUYRATE" class="font-weight-medium body-2"> {{ item.BUYRATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUYAMT" class="font-weight-medium caption"> {{ item.BUYAMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </td>

                                <td class="  text-right" style="width: 150px">
                                  <span v-if="item.SALEQTY" class="font-weight-medium body-2"> {{ item.SALEQTY }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </td>
                                <td style="width: 130px" class="pr-0  text-right">
                                  <span v-if="item.SALERATE" class="font-weight-medium body-2"> {{ item.SALERATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALEAMT" class="font-weight-medium caption"> {{ item.SALEAMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>

                                </td>
                                <td class=" text-right pr-2 " style="width: 160px">
                                  <span v-if="item.NETQTY" class="font-weight-medium body-2"> {{ item.NETQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>


                                </td>
                                <td class=" text-right " style="width: 200px">
                                  <span v-if="item.NETRATE" class="font-weight-medium body-2"> {{ item.NETRATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NETAMT" class="font-weight-medium caption"> {{ item.NETAMOUNT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </td>
                                <td style="width: 200px" class=" pr-0 text-right">
                                  <span v-if="item.CL_PRICE" class="font-weight-medium body-2"> {{ item.CL_PRICE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>

                                </td>

                                <td style="width: 250px" class="  text-right">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2"
                                    style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>

                                </td>
                                <td style="width: 80px">

                                </td>

                              </tr>
                            </template>

                            <!-- <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                              <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                            </template>
                            <template v-slot:[`item.NET_QTY`]="{ item }">
                              <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.NET_RATE`]="{ item }">
                              <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                              <br>
                              <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_QTY`]="{ item }">
                              <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_RATE`]="{ item }">
                              <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                              <span v-else class="font-weight-medium caption">0</span>
                            </template>
                            <template v-slot:[`item.SALE_QTY`]="{ item }">
                              <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.SALE_RATE`]="{ item }">
                              <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.Closing_Price`]="{ item }">
                              <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price
                              }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                              <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template>
                            <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                              <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2" style="color: green">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2" style="color: black">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template> -->
                          </v-data-table>
                          <!-- v-else -->
                          <!-- <v-data-table  :headers="dessertHeaders" :items="dessertsexpand"
                                :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer;  "
                                class="elevation-0 rounded-lg pa-4" fixed-header hide-header @click:row="toggleExpanded4"
                                :loading="loader" height="400px" hide-default-footer hide-default-header show-expand
                                :expanded.sync="expandedinner" item-key="name">
                                <template v-slot:[`item.name`]="{ item }">
                                  <span class="font-weight-bold body-1"> {{ item.name }}</span>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                            <td class="px-0" :colspan="headers.length">
                              <v-data-table style="border: 1px solid rgb(233, 233, 233); border-radius: 10px"
                                :items-per-page="item.val.length" height="300px" item fixed-header hide-default-footer dense
                                :headers="headersexpandinside" :items="item.val" item-key="name" class="elevation-0">
                                <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                                </template>
                                <template v-slot:[`item.NET_QTY`]="{ item }">
                                  <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.NET_RATE`]="{ item }">
                                  <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_QTY`]="{ item }">
                                  <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_RATE`]="{ item }">
                                  <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </template>
                                <template v-slot:[`item.SALE_QTY`]="{ item }">
                                  <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.SALE_RATE`]="{ item }">
                                  <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.Closing_Price`]="{ item }">
                                  <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                                  <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                                <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                              </v-data-table>

                            </td>
                          </template>
                        </v-data-table> -->
                        </td>
                      </template>
                    </v-data-table>


                  </v-tab-item>


                  <v-tab-item>
                    <v-data-table :headers="dessertHeaders" :items="dessertsexpandcurrency"
                      :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer"
                      class="cust-table elevation-0 rounded-lg cell-height " fixed-header @click:row="toggleExpanded3"
                      :loading="eqloader" height="495px" hide-default-footer show-expand :expanded.sync="expandedcur"
                      item-key="name" disable-sort>

                      <template v-slot:[`item.name`]="{ item }">
                        <span class="overline"> {{ item.name
                          }}</span>
                      </template>
                      <template v-slot:no-data>
                        <v-col class="mx-auto pa-15 mx-0 px-0 " style="background-color: white ;">
                          <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                          <p class="font-weight-bold black--text">No data available
                          </p>
                        </v-col>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td class="px-0" :colspan="headers.length">
                          <!-- v-if="item.name != 'Assets'" -->
                          <v-data-table :items-per-page="item.val.length" item fixed-header hide-default-footer dense
                            :headers="headersexpandinsidecom" hide-default-header :items="item.val" item-key="name"
                            class="elevation-0">


                            <template v-slot:item="{ item }">
                              <tr class="" style="position: relative">

                                <td class="" style="width:700px">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_SYMBOL }}

                                    <v-tooltip color="black" v-if="item.OPQTY > 0 || item.OPQTY < 0" v-model="item.show"
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="blue" class="ml-2" x-small outlined>{{
                                          item.OPQTY }}</v-chip>
                                      </template>
                                      <span>Open Quantity!</span>
                                    </v-tooltip>

                                  </span>

                                </td>


                                <td class=" text-right" style="width: 160px">
                                  <span v-if="item.BUYQTY" class="font-weight-medium body-2"> {{ item.BUYQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>

                                <td class=" text-right pl-0" style="width: 160px">
                                  <span v-if="item.BUYRATE" class="font-weight-medium body-2"> {{ item.BUYRATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUYAMT" class="font-weight-medium caption"> {{ item.BUYAMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </td>

                                <td class="  text-right" style="width: 150px">
                                  <span v-if="item.SALEQTY" class="font-weight-medium body-2"> {{ item.SALEQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </td>
                                <td style="width: 130px" class="pr-0  text-right">
                                  <span v-if="item.SALERATE" class="font-weight-medium body-2"> {{ item.SALERATE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALEAMT" class="font-weight-medium caption"> {{ item.SALEAMT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>

                                </td>
                                <td class=" text-right pr-2 " style="width: 160px">
                                  <span v-if="item.NETQTY" class="font-weight-medium body-2"> {{ item.NETQTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>


                                </td>
                                <td class=" text-right " style="width: 200px">
                                  <span v-if="item.NETRATE" class="font-weight-medium body-2"> {{ item.NETRATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NETAMT" class="font-weight-medium caption"> {{ item.NETAMOUNT
                                    }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </td>
                                <td style="width: 200px" class=" pr-0 text-right">
                                  <span v-if="item.CL_PRICE" class="font-weight-medium body-2"> {{ item.CL_PRICE
                                    }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>

                                </td>

                                <td style="width: 250px" class="  text-right">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2"
                                    style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>

                                </td>
                                <td style="width: 80px">

                                </td>

                              </tr>
                            </template>

                            <!-- <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                              <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                            </template>
                            <template v-slot:[`item.NET_QTY`]="{ item }">
                              <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.NET_RATE`]="{ item }">
                              <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                              <br>
                              <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_QTY`]="{ item }">
                              <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.BUY_RATE`]="{ item }">
                              <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                              <span v-else class="font-weight-medium caption">0</span>
                            </template>
                            <template v-slot:[`item.SALE_QTY`]="{ item }">
                              <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.SALE_RATE`]="{ item }">
                              <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                              <br>
                              <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                              <span v-else class="font-weight-medium caption"> 0</span>
                            </template>
                            <template v-slot:[`item.Closing_Price`]="{ item }">
                              <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price
                              }}</span>
                              <span v-else class="font-weight-medium body-2"> 0</span>
                            </template>
                            <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                              <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT
                              }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template>
                            <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                              <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2" style="color: green">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2" style="color: black">
                                {{ item.NOTIONAL_NET }}</span>
                              <span v-else class="font-weight-medium body-2">0</span>
                            </template> -->
                          </v-data-table>
                          <!-- v-else -->
                          <!-- <v-data-table  :headers="dessertHeaders" :items="dessertsexpand"
                                :single-expand="singleExpand" style="border: 1px solid #efeef3; cursor: pointer;  "
                                class="elevation-0 rounded-lg pa-4" fixed-header hide-header @click:row="toggleExpanded4"
                                :loading="loader" height="400px" hide-default-footer hide-default-header show-expand
                                :expanded.sync="expandedinner" item-key="name">
                                <template v-slot:[`item.name`]="{ item }">
                                  <span class="font-weight-bold body-1"> {{ item.name }}</span>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                            <td class="px-0" :colspan="headers.length">
                              <v-data-table style="border: 1px solid rgb(233, 233, 233); border-radius: 10px"
                                :items-per-page="item.val.length" height="300px" item fixed-header hide-default-footer dense
                                :headers="headersexpandinside" :items="item.val" item-key="name" class="elevation-0">
                                <template v-slot:[`item.SCRIP_NAMEDATA`]="{ item }">
                                  <span class="font-weight-bold body-2"> {{ item.SCRIP_NAMEDATA }}</span>
                                </template>
                                <template v-slot:[`item.NET_QTY`]="{ item }">
                                  <span v-if="item.NET_QTY" class="font-weight-medium body-2"> {{ item.NET_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.NET_RATE`]="{ item }">
                                  <span v-if="item.NET_RATE" class="font-weight-medium body-2"> {{ item.NET_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                  <br>
                                  <span v-if="item.NET_AMOUNT" class="font-weight-medium caption"> {{ item.NET_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_QTY`]="{ item }">
                                  <span v-if="item.BUY_QTY" class="font-weight-medium body-2"> {{ item.BUY_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.BUY_RATE`]="{ item }">
                                  <span v-if="item.BUY_RATE" class="font-weight-medium body-2"> {{ item.BUY_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.BUY_AMT" class="font-weight-medium caption"> {{ item.BUY_AMT }}</span>
                                  <span v-else class="font-weight-medium caption">0</span>
                                </template>
                                <template v-slot:[`item.SALE_QTY`]="{ item }">
                                  <span v-if="item.SALE_QTY" class="font-weight-medium body-2"> {{ item.SALE_QTY }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.SALE_RATE`]="{ item }">
                                  <span v-if="item.SALE_RATE" class="font-weight-medium body-2"> {{ item.SALE_RATE }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                  <br>
                                  <span v-if="item.SALE_AMT" class="font-weight-medium caption"> {{ item.SALE_AMT }}</span>
                                  <span v-else class="font-weight-medium caption"> 0</span>
                                </template>
                                <template v-slot:[`item.Closing_Price`]="{ item }">
                                  <span v-if="item.Closing_Price" class="font-weight-medium body-2"> {{ item.Closing_Price }}</span>
                                  <span v-else class="font-weight-medium body-2"> 0</span>
                                </template>
                                <template v-slot:[`item.CURR_AMOUNT`]="{ item }">
                                  <span v-if="item.CURR_AMOUNT" class="font-weight-medium body-2"> {{ item.CURR_AMOUNT }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                                <template v-slot:[`item.NOTIONAL_NET`]="{ item }">
                                  <span v-if="item.NOTIONAL_NET < 0" class="font-weight-medium body-2" style="color: red">
                                    {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET > 0" class="font-weight-medium body-2"
                                    style="color: green"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else-if="item.NOTIONAL_NET == 0" class="font-weight-medium body-2"
                                    style="color: black"> {{ item.NOTIONAL_NET }}</span>
                                  <span v-else class="font-weight-medium body-2">0</span>
                                </template>
                              </v-data-table>

                            </td>
                          </template>
                        </v-data-table> -->
                        </td>
                      </template>
                    </v-data-table>


                  </v-tab-item>
                </v-tabs-items>

                <v-dialog v-model="newpopupstat" width="700" class="text-center">

                  <v-card class="pb-10">
                    <v-toolbar class=" mb-1 px-1 toolbar-contant" elevation="0" color="white">
                      <v-list class="mr-2" style="background-color: transparent;">
                        <v-list-item class="px-0 pt-4">
                          <v-list-item-content class=" pt-0">
                            <v-list-item-title class="text-start"
                              style="color: #000000;font-size: 20px;font-weight:559;line-height:19px;letter-spacing:-1px">
                              Bifurcation of Bill
                            </v-list-item-title>

                            <!-- <v-list-item-subtitle class="text-start "
                              style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">
                              Straight to the point about profit and loss analysis.
                            </v-list-item-subtitle> -->

                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="newpopupstat = false"><v-icon>mdi mdi-close</v-icon></v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <!-- <div class="     d-none d-md-block pa-8">

                      <v-row v-if="tab == 0">
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Long Term Realized P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="longnetval < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (longnetval).toFixed(2) }} </p>
                                <p class="mb-0" v-if="longnetval > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (longnetval).toFixed(2) }} </p>
                                <p class="mb-0" v-if="longnetval == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (longnetval).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Short Term Realized P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="stnetamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (stnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="stnetamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (stnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="stnetamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (stnetamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Trading P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="tradenetamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (tradenetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="tradenetamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (tradenetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="tradenetamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (tradenetamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>


                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Assets P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="assnetamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (assnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="assnetamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (assnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="assnetamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (assnetamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Trading Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="totalintraday < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (totalintraday).toFixed(2) }} </p>
                                <p class="mb-0" v-if="totalintraday > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (totalintraday).toFixed(2) }} </p>
                                <p class="mb-0" v-if="totalintraday == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (totalintraday).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Total Charges</p>
                            <v-progress-linear style="width: 30px" v-if="segloader" indeterminate
                              color="blue"></v-progress-linear>
                            <v-divider v-else-if="!segloader" class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (segval).toFixed(2) }} </p>

                              </v-card>
                            </div>
                          </v-card>
                        </v-col>


                      </v-row>
                      <v-row v-else-if="tab == 1">
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="futopened < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futopened).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futopened > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futopened).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futopened == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futopened).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="futurnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futurnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futurnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futurnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futurnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futurnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Total Charges</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (derchargers).toFixed(2) }} </p>

                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="optionopn < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (optionopn).toFixed(2) }} </p>
                                <p class="mb-0" v-if="optionopn > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (optionopn).toFixed(2) }} </p>
                                <p class="mb-0" v-if="optionopn == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (optionopn).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="opturnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (opturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="opturnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (opturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="opturnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (opturnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>


                      </v-row>

                      <v-row v-else-if="tab == 2">
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="comnetfutamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetfutamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comnetfutamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetfutamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comnetfutamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetfutamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="futturnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futturnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="futturnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (futturnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Total Charges</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comchargers).toFixed(2) }} </p>

                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="comnetamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comnetamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comnetamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comnetamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="comturnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comturnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comturnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comturnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>

                      </v-row>



                      <v-row v-else-if="tab == 3">
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="curnetfutamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curnetfutamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curnetfutamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curnetfutamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curnetfutamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curnetfutamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Futures Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="curfutturnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curfutturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curfutturnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curfutturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curfutturnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curfutturnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Total Charges</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curchargers).toFixed(2) }} </p>

                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options P&L</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="curopnetamt < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curopnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curopnetamt > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curopnetamt).toFixed(2) }} </p>
                                <p class="mb-0" v-if="curopnetamt == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (curopnetamt).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="4">
                          <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                            <p class="pt-1 mb-3"
                              style="font-weight:450;font-size: 14px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                              Options Turnover</p>
                            <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                              color="#000000"></v-divider>
                            <div class="display-flex row pt-6 pl-2">
                              <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                <p class="mb-0" v-if="comopturnover < 0"
                                  style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comopturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comopturnover > 0"
                                  style="color: green;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comopturnover).toFixed(2) }} </p>
                                <p class="mb-0" v-if="comopturnover == 0"
                                  style="color: black;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                  {{ (comopturnover).toFixed(2) }} </p>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>



                      </v-row>
                    </div>
                    <div>
                      <v-card v-if="tab == 0" color="#eeeeee" outlined
                        class="mx-2 mt-4 d-md-none elevation-0 rounded-lg pa-6">

                        <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0 d-md-none">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Long Term Realized P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="longnetval < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (longnetval).toFixed(2) }}

                                  </p>
                                  <p v-else-if="longnetval > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (longnetval).toFixed(2) }}

                                  </p>
                                  <p v-else-if="longnetval == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ longnetval }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Short Term Realized P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="stnetamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (stnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="stnetamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (stnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="(stnetamt).toFixed(2) == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ stnetamt }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Trading P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="tradenetamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (tradenetamt).toFixed(2) }}

                                  </p>
                                  <p v-if="tradenetamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (tradenetamt).toFixed(2) }}

                                  </p>
                                  <p v-if="tradenetamt == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (tradenetamt).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Assets P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="assnetamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (assnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="assnetamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (assnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="(assnetamt).toFixed(2) == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ assnetamt }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Trading Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="totalintraday < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (totalintraday).toFixed(2) }}

                                  </p>
                                  <p v-if="totalintraday > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (totalintraday).toFixed(2) }}

                                  </p>
                                  <p v-if="totalintraday == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (totalintraday).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Total Charges</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="segval < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (segval).toFixed(2) }}

                                  </p>
                                  <p v-if="segval > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (segval).toFixed(2) }}

                                  </p>
                                  <p v-if="segval == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (segval).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>


                          </v-row>
                        </v-card>
                      </v-card>
                      <v-card v-else-if="tab == 1" color="#eeeeee" outlined
                        class="mx-2 mt-4 d-md-none elevation-0 rounded-lg pa-6">

                        <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="futopened < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (futopened).toFixed(2) }}

                                  </p>
                                  <p v-if="futopened > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (futopened).toFixed(2) }}

                                  </p>
                                  <p v-if="futopened == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (futopened).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="futurnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (futurnover).toFixed(2) }}

                                  </p>
                                  <p v-if="futurnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (futurnover).toFixed(2) }}

                                  </p>
                                  <p v-if="futurnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (futurnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="optionopn < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (optionopn).toFixed(2) }}

                                  </p>
                                  <p v-else-if="optionopn > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (optionopn).toFixed(2) }}

                                  </p>
                                  <p v-else-if="optionopn == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (optionopn).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="opturnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (opturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="opturnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (opturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="opturnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (opturnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Total Charges</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="derchargers < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (derchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="derchargers > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (derchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="derchargers == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (derchargers).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>


                          </v-row>
                        </v-card>
                      </v-card>
                      <v-card v-else-if="tab == 2" color="#eeeeee" outlined
                        class="mx-2 mt-4 d-md-none elevation-0 rounded-lg pa-6">

                        <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="comnetfutamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (comnetfutamt).toFixed(2) }}

                                  </p>
                                  <p v-if="comnetfutamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (comnetfutamt).toFixed(2) }}

                                  </p>
                                  <p v-if="comnetfutamt == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (comnetfutamt).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="futturnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (futturnover).toFixed(2) }}

                                  </p>
                                  <p v-if="futturnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (futturnover).toFixed(2) }}

                                  </p>
                                  <p v-if="futturnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (futturnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="comnetamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (comnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comnetamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (comnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comnetamt == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (comnetamt).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="comturnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (comturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comturnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (comturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comturnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (comturnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Total charges</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="comchargers < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (comchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comchargers > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (comchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comchargers == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (comchargers).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>


                          </v-row>
                        </v-card>
                      </v-card>
                      <v-card v-else-if="tab == 3" color="#eeeeee" outlined
                        class="mx-2 mt-4 d-md-none elevation-0 rounded-lg  pa-6">

                        <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="curnetfutamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (curnetfutamt).toFixed(2) }}

                                  </p>
                                  <p v-if="curnetfutamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (curnetfutamt).toFixed(2) }}

                                  </p>
                                  <p v-if="curnetfutamt == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (curnetfutamt).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Futures Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="curfutturnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (curfutturnover).toFixed(2) }}

                                  </p>
                                  <p v-if="curfutturnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (curfutturnover).toFixed(2) }}

                                  </p>
                                  <p v-if="curfutturnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (curfutturnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options P&L</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="curopnetamt < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (curopnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="curopnetamt > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (curopnetamt).toFixed(2) }}

                                  </p>
                                  <p v-else-if="curopnetamt == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (curopnetamt).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Options Turnover</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="comopturnover < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (comopturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comopturnover > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (comopturnover).toFixed(2) }}

                                  </p>
                                  <p v-else-if="comopturnover == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (comopturnover).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-row no-gutters>
                                <v-col cols="5">
                                  <p class="caption"
                                    style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                    Total charges</p>
                                </v-col>
                                <v-col cols="7">
                                  <p v-if="curchargers < 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #E12626; ">
                                    {{ (curchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="curchargers > 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #34A853; ">
                                    {{ (curchargers).toFixed(2) }}

                                  </p>
                                  <p v-else-if="curchargers == 0" class="ctnbtl body-1 text-right"
                                    style="line-height:28px; color: #505359; ">
                                    {{ (curchargers).toFixed(2) }}

                                  </p>
                                </v-col>
                              </v-row>
                            </v-col>


                          </v-row>
                        </v-card>
                      </v-card>
                    </div> -->
                    <v-data-table hide-default-footer dense outlined :headers="headersBifurcation"
                      :items="dataBifurcation()" :items-per-page="-1" class="elevation-1 mx-12 mt-5 d-none d-md-block"></v-data-table>

                      <div class="d-md-none ma-8"><div   class="d-flex">
                      <p class="body-1">
                        Particulars
                      </p>
                      <p class="body-1 ml-auto">
                        {{  tab == 0 ? 'Equity' : tab == 1 ? 'Derivative' : tab == 2 ? 'Commodity' : 'Currency' }}
                      </p>
                    </div>
                    <div v-for="(item, index) in dataBifurcation()" :key="index" class="d-flex">
                      <p class="caption">
                        {{ item.name }}
                      </p>
                      <p class="caption ml-auto">
                        {{ item.value }}
                      </p>
                    </div></div>





                  </v-card>
                </v-dialog>
              </div>
            </div>
          </v-card>
        </v-col>
      </div>

      <div class="d-md-none">
        <v-toolbar class="mt-6 mb-1 px-2  toolbar-contant" elevation="0" color="white">
          <v-list class="pb-0" style="background-color: transparent;">
            <v-list-item class=" pt-0 px-0">

              <v-list-item-content class=" pt-0">
                <v-list-item-title class="text-start"
                  style="color: #000000;font-size: 20px;font-weight:559;line-height:16px;letter-spacing:-1px">
                  Tax P&L </v-list-item-title>

                <v-list-item-subtitle class="text-start pt-1"
                  style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Profit
                  and Loss of your trades.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-spacer></v-spacer>
          <v-list class=" pt-0" style="background-color: transparent;">
            <v-list-item class="pl-0 pa-0" style="min-height: 0px;">

            </v-list-item>

          </v-list>
        </v-toolbar>
        <v-divider class=" mx-2"></v-divider>
        <v-card color="#eeeeee" outlined class="mx-2 mt-4 d-md-none elevation-0 rounded-lg pa-6">
          <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0 d-md-none">
            <v-row no-gutters>
              <v-col cols="12" @click="opendetailstat(newstateq, 0)">
                <v-row no-gutters>
                  <v-col cols="5">
                    <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                      Equity Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon> </p>
                  </v-col>
                  <v-col cols="7">
                    <p :style="{
                      color: (
                        (newstateq?.trading || 0) +
                        (newstateq?.delivery_sell || 0) -
                        (newstateq?.delivery_buy || 0) +
                        (segval || 0)
                      ) > 0 ? 'green' : (
                        (newstateq?.trading || 0) +
                        (newstateq?.delivery_sell || 0) -
                        (newstateq?.delivery_buy || 0) +
                        (segval || 0)
                      ) < 0 ? 'red' : 'black',
                    }" class="ctnbtl body-1 text-right" style="line-height:28px;  ">
                      {{
                        (
                          (newstateq?.trading || 0) +
                          (newstateq?.delivery_sell || 0) -
                          (newstateq?.delivery_buy || 0) +
                          (segval || 0)
                        ).toFixed(2)
                      }}

                    </p>

                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" @click="opendetailstat(newstat?.der_total, 1)">
                <v-row no-gutters>
                  <v-col cols="5">
                    <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                      Derivative Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon></p>
                  </v-col>
                  <v-col cols="7">
                    <p :style="{
                      color:
                        (newstat?.der_total?.der_total_value || 0) > 0 ? 'green' : (
                          (newstat?.der_total?.der_total_value || 0)
                        ) < 0 ? 'red' : 'black',
                    }" class="ctnbtl body-1 text-right" style="line-height:28px;   ">
                      {{
                        newstat?.der_total?.der_total_value?.toFixed(2) || 0
                      }}

                    </p>

                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" @click="opendetailstat(newstat?.com_total, 2)">
                <v-row no-gutters>
                  <v-col cols="5">
                    <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                      Commodity Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon></p>
                  </v-col>
                  <v-col cols="7">
                    <p :style="{
                      color:
                        (newstat?.com_total?.com_total_value || 0) > 0 ? 'green' : (
                          (newstat?.com_total?.com_total_value || 0)
                        ) < 0 ? 'red' : 'black',
                    }" class="ctnbtl body-1 text-right" style="line-height:28px;  ">
                      {{
                        newstat?.com_total?.com_total_value?.toFixed(2) || 0
                      }}

                    </p>

                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" @click="opendetailstat(newstat?.curr_total, 3)">
                <v-row no-gutters>
                  <v-col cols="5">
                    <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                      Currency Net <v-icon size="18" class="mt-n1" color="#0037B7">mdi mdi-menu-right</v-icon></p>
                  </v-col>
                  <v-col cols="7">
                    <p :style="{
                      color:
                        (newstat?.curr_total?.curr_total_value || 0) > 0 ? 'green' : (
                          (newstat?.curr_total?.curr_total_value || 0)
                        ) < 0 ? 'red' : 'black',
                    }" class="ctnbtl body-1 text-right" style="line-height:28px;  ">
                      {{
                        newstat?.curr_total?.curr_total_value?.toFixed(2) || 0
                      }}

                    </p>

                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card>

        <div class="text-center">
          <v-bottom-sheet v-model="sheet" inset>

            <v-sheet class="text-center" height="200px">
              <!-- <v-btn class="mt-n6" icon text color="error" @click="sheet = !sheet">
                              <v-icon size="40">mdi mdi-close-circle</v-icon>
                          </v-btn> -->
              <!-- {{ radios }}/ -->
              <p class="mb-0 pt-3 title font-weight-medium">Summary P&L</p>
              <v-card class="elevation-0 ma-8 mt-0">
                <v-radio-group class="mt-0" v-model="radios" mandatory>
                  <v-radio color="black" label="Download Pdf" value="Download Pdf"></v-radio>
                  <v-radio color="black" label="Download Excel" value="Download Excel"></v-radio>
                </v-radio-group>
                <v-btn @click="downloadsum(radios)" class="white--text elevation-0" color="black" block rounded flat
                  solo>
                  {{
                    radios }}</v-btn>
              </v-card>
            </v-sheet>
          </v-bottom-sheet>
        </div>
        <div class="text-center">
          <v-bottom-sheet v-model="sheet1" inset>

            <v-sheet class="text-center" height="200px">
              <!-- <v-btn class="mt-n6" icon text color="error" @click="sheet1 = !sheet1">
                              <v-icon size="40">mdi mdi-close-circle</v-icon>
                          </v-btn> -->
              <!-- {{ radios }}/ -->
              <p class="mb-0 pt-3 title font-weight-medium">Tax PnlL</p>

              <v-card class="elevation-0 ma-8 mt-0">
                <v-radio-group class="mt-0" v-model="radios1" mandatory>
                  <v-radio color="black" label="Download Pdf" value="Download Pdf"></v-radio>
                  <v-radio color="black" label="Download Excel" value="Download Excel"></v-radio>
                </v-radio-group>
                <v-btn @click="valdwl(radios1)" class="white--text elevation-0" color="black" block rounded flat solo>
                  {{
                    radios1 }}</v-btn>
              </v-card>
            </v-sheet>
          </v-bottom-sheet>
        </div>
        <!-- <v-divider class="mt-4 mb-2 "></v-divider>
        <div class="d-flex row">
          <p v-if="summary" class="text-start mt-3 mb-3  ml-2 px-4 "
            style="color: #696969;font-size: 12px;font-weight:500;line-height:16px;">
            No of symbols
            <span class=" pa-1 rounded-lg" style=" color: #000000;">({{ dessertsoriginal.length }})</span>
          </p>
          <p v-if="!summary" class="text-start mt-3 mb-3  ml-2 px-4 "
            style="color: #696969;font-size: 12px;font-weight:500;line-height:16px;">
            No of symbols
            <span class=" pa-1 rounded-lg" style=" color: #000000;">({{ desserts23.length }})</span>
          </p>
          <v-btn v-if="summary" @click="sheet = true" class="ml-auto mr-6 " flat solo icon> <v-icon>mdi
              mdi-download</v-icon></v-btn>
          <v-btn v-if="!summary" @click="sheet1 = true" class="ml-auto mr-6 " flat solo icon> <v-icon>mdi
              mdi-download</v-icon></v-btn>
        </div> -->
        <v-divider class="mb-2 mt-2"></v-divider>
        <v-row class="px-5 pa-0 mt-3">

          <!-- <v-col class=" pa-0 px-2">
            <v-text-field v-if="summary" style="width:100%;" class="tophundraedmutual  " height="36px"
              background-color="#F1F3F8" label="Search" v-model="search" solo rounded flat dense>
              <template v-slot:prepend-inner>
                <img alt="" class="shrink" :src="require('@/assets/searchicon.svg')" width="20px" height="18px" />
              </template>
            </v-text-field>
            <v-text-field v-if="!summary" style="width:100%;" class="tophundraedmutual  " height="36px"
              background-color="#F1F3F8" label="Search" v-model="searchde" solo rounded flat dense>
              <template v-slot:prepend-inner>
                <img alt="" class="shrink" :src="require('@/assets/searchicon.svg')" width="20px" height="18px" />
              </template>
            </v-text-field>
          </v-col> -->
          <v-col class="mb-3 d-flex" cols="6">
            <!-- <v-select v-if="summary" :items="filterr" @change="filterseg(filterdata_unpl)" dense v-model="filterdata_unpl"
              placeholder="filter" solo rounded flat background-color="#F1F3F8" hide-details class=""
              style="max-width: 100%; font-size: 21px">
            </v-select> -->
            <v-select style="max-width: 100%; font-size: 21px;overflow: hidden" dense background-color="#F1F3F8"
              :loading="disabletabs" rounded :readonly="disabletabs && disabletabsexpense" @change="gettaxpnl(yearis)"
              :items="items" v-model="yearis" flat solo class="mr-2 mt-n3 fildrop" label="From"
              prepend-inner-icon="mdi-calendar" hide-details append-icon="mdi-chevron-down"></v-select>

            <!-- {{disdowbtn}} -->
            <v-btn :disabled="disdowbtn" @click="sheet1 = true" class="ml-auto mr-6 mt-n3" flat solo icon> <v-icon>mdi
                mdi-download</v-icon></v-btn>
            <!-- <v-select v-if="!summary" :items="filterr" @change="filterseg1(filterdata_unpl1)" dense
              v-model="filterdata_unpl1" placeholder="filter" solo rounded flat background-color="#F1F3F8" hide-details
              class="mr-2 mt-n3 fildrop" style="max-width: 100%; font-size: 21px">
            </v-select> -->
          </v-col>
        </v-row>

        <v-row class="pt-0 mt-n3">
          <v-col lg="4" sm="12" md="12" cols="12">
            <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
              <!-- @click="summary1()"   -->
              <v-tabs v-model="tab" background-color="transparent" color="basil" grow>

                <v-tab v-model="tab2" @click="tabdata('Equities')">
                  Equities
                </v-tab>

                <v-tab style="cursor: wait;" v-if="disabletabs" disabled>
                  Derivatives
                </v-tab>

                <v-tab v-else-if="!disabletabs" v-model="tab3" @click="tabdata('Derivatives')">
                  Derivatives
                </v-tab>

                <v-tab :disabled="disabletabs" v-model="tab4" @click="tabdata('Commodity')">
                  Commodity
                </v-tab>
                <v-tab :disabled="disabletabs" v-model="tab5" @click="tabdata('Currency')"
                  :class="{ 'red-text': disabletabs }">
                  Currency
                </v-tab>

                <!-- <div v-else-if="!disabletabs">
  <v-tab v-model="tab3" @click="tabdata('Derivatives')">
    Derivatives
  </v-tab>
  <v-tab v-model="tab4" @click="tabdata('Commodity')">
    Commodity
  </v-tab>
  <v-tab v-model="tab5" @click="tabdata('Currency')">
    Currency
  </v-tab>
</div> -->
              </v-tabs>

            </v-tabs>

          </v-col>

        </v-row>
        <!-- {{ loader }} -->
        <v-dialog fullscreen transition="dialog-bottom-transition" v-model="dialogmobile">
          <v-sheet class="text-center" style="height: 100vh">
            <v-list-item-content class=" pt-5 pl-5">
              <v-list-item-title class="text-start"
                style="color: #000000;font-size: 18px;font-weight:559;line-height:24px;letter-spacing:-1px">
                Detailed P&L</v-list-item-title>

              <v-list-item-subtitle class="text-start pt-1"
                style="color: #666666;font-size: 11px;font-weight:469;line-height:14px"> {{ scriptname }}
              </v-list-item-subtitle>
              <v-btn absolute right top icon color="black" @click="dialogmobile = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-content>
            <v-divider></v-divider>

            <v-card color="#eeeeee" outlined class="d-md-none elevation-0 rounded-lg pa-6 mt-3 px-3" height="90%"
              style="overflow: scroll">
              <div class="text-center pa-4">
                <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                  Total</p>
                <p v-if="finaltotal < 0" class="ctnbtl headline mb-0" style="line-height:28px; color: red; ">
                  {{ (finaltotal).toFixed(2) }}</p>
                <p v-if="finaltotal > 0" class="ctnbtl headline mb-0" style="line-height:28px; color: green; ">
                  {{ finaltotal }}</p>
                <p v-if="finaltotal == 0" class="ctnbtl headline mb-0" style="line-height:28px; color: rgb(0, 0, 0); ">
                  {{ finaltotal }}</p>
                <p v-if="finaltotal == ''" class="ctnbtl headline mb-0" style="line-height:28px;  ">
                  -</p>
              </div>
              <v-card v-for="item in detailedpoparray" :key="item.index" style="border-top: 5px #F1F3F8 solid;"
                class="elevation-0  px-4" width="100%">
                <span class="d-flex row mt-3 mb-3 px-4">
                  <p class="  pb-0 mb-0" style="color: #000000;font-size: 15px;font-weight:459;">{{
                    item.TRADE_DATE }}
                  </p>
                  <p v-if="item.NETAMT > 0" class="mb-0 ml-auto body-2 font-weight-regular" style="color: green;">
                    {{ item.NETAMT }}</p>
                  <p v-if="item.NETAMT < 0" class="mb-0 ml-auto body-2 font-weight-regular" style="color: red;">{{
                    item.NETAMT }}</p>
                  <p v-if="item.NETAMT == 0" class="mb-0 ml-auto body-2 font-weight-regular" style="color: #000000;">
                    {{ item.NETAMT }}</p>
                </span>

                <v-divider class="mb-2"></v-divider>
                <v-row class="px-2">
                  <v-col>
                    <p class="mb-1 body-2 font-weight-regular text-start" style="color: #666666;">Net
                      Quantity:
                      <span class="mb-0 body-2 font-weight-regular text-start" style="color: #000000;">{{
                        item.NETQTY
                      }}</span>
                    </p>
                    <p class="mb-1 body-2 font-weight-regular text-start" style="color: #666666;">Buy
                      Quantity:
                      <span class="mb-0 body-2 font-weight-regular text-start" style="color: #000000;">{{
                        item.BQTY
                      }}</span>
                    </p>
                    <p class="mb-3 body-2 font-weight-regular text-start" style="color: #666666;">Buy
                      Rate :
                      <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.BRATE }}</span>
                    </p>
                  </v-col>
                  <v-col class="text-end">
                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net
                      Rate: <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        (item.NRATE).toFixed(2) }}
                      </span>
                    </p>
                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sale
                      Quantity: <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ item.SQTY }}
                      </span>
                    </p>
                    <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sale Rate :
                      <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SRATE }}
                      </span>
                    </p>
                  </v-col>
                </v-row>
              </v-card>
              <v-card v-if="loader" style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;"
                class="elevation-0  px-4" width="100%">
                <v-row class="px-2">
                  <v-col class="mx-auto text-center my-4">
                    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-sheet>
        </v-dialog>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <!-- <v-card v-for="item in dessertsexpand " :key="item.index" style="border-top: 5px #F1F3F8 solid;"
              class="elevation-0  px-4 pt-2" width="100%"> -->

            <!-- <span @click="detailedpopmobile(item)" class="font-weight-bold">

           

                <span>{{ item.name }}<v-icon color="#0037B7">mdi
                    mdi-menu-right</v-icon></span>
             
              </span> -->
            <v-expansion-panels inset style="z-index: 0">
              <v-expansion-panel v-for="(item, i) in dessertsexpand" :key="i">
                <v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card v-for="iitem in item.val" :key="iitem.index" style="border-top: 5px #F1F3F8 solid;"
                    class="elevation-0  px-4 pt-2" width="100%">

                    <span class="font-weight-bold">

                      {{ iitem.SCRIP_NAMEDATA }}

                      <!-- {{ item.COMPANY_CODE }} -->
                      <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                    </span>
                    <v-divider class="mb-2 mt-2"></v-divider>
                    <v-row class="px-2">
                      <v-col>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                        </p>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.BUY_QTY
                            }}</span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ iitem.BUY_RATE
                            }}</span>
                        </p>
                      </v-col>
                      <v-col class="text-end">
                        <p v-if="iitem.NET_AMOUNT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                          iitem.NET_AMOUNT }}</p>
                        <p v-if="iitem.NET_AMOUNT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                          iitem.NET_AMOUNT }}</p>
                        <p v-if="iitem.NET_AMOUNT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                          {{ iitem.NET_AMOUNT }}</p>

                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              item.SALE_QTY }}

                          </span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              item.SALE_RATE
                            }}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-divider class="mb-2 mt-2"></v-divider>
              <v-row class="px-2">
                <v-col>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                  </p>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.BUY_QUANTITY
                      }}</span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ item.BUY_RATE
                      }}</span>
                  </p>
                </v-col>
                <v-col class="text-end">
                  <p v-if="item.NET_AMOUNT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                    {{ item.NET_AMOUNT }}</p>

                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_QUANTITY }}

                    </span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_RATE
                      }}</span>
                  </p>
                </v-col>
              </v-row> -->
            <!-- </v-card> -->
            <v-card v-if="dessertsexpand.length == 0 && loader == false"
              style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;" class="elevation-0  px-4"
              width="100%">
              <v-row class="px-2">
                <v-col class="mx-auto text-center my-4">
                  <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                  <p class="font-weight-bold black--text">No data available</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card v-if="loader" style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;"
              class="elevation-0  px-4" width="100%">
              <v-row class="px-2 ">
                <v-col class="mx-auto text-center my-10">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <!-- <v-card v-for="item in dessertsexpand " :key="item.index" style="border-top: 5px #F1F3F8 solid;"
              class="elevation-0  px-4 pt-2" width="100%"> -->

            <!-- <span @click="detailedpopmobile(item)" class="font-weight-bold">

           

                <span>{{ item.name }}<v-icon color="#0037B7">mdi
                    mdi-menu-right</v-icon></span>
             
              </span> -->
            <v-expansion-panels inset style="z-index: 0">

              <v-expansion-panel v-for="(item, i) in dessertsexpandderivative" :key="i">
                <v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card v-for="iitem in item.val" :key="iitem.index" style="border-top: 5px #F1F3F8 solid;"
                    class="elevation-0  px-4 pt-2" width="100%">

                    <span class="font-weight-bold">

                      {{ iitem.SCRIP_SYMBOL }}

                      <!-- {{ item.COMPANY_CODE }} -->
                      <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                    </span>
                    <v-divider class="mb-2 mt-2"></v-divider>
                    <v-row class="px-2">
                      <v-col>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                        </p>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.BUYQTY
                            }}</span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ iitem.BUYRATE
                            }}</span>
                        </p>
                      </v-col>
                      <v-col class="text-end">
                        <p v-if="iitem.NETAMT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                          {{ iitem.NETAMT }}</p>

                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALEQTY }}

                          </span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALERATE
                            }}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-divider class="mb-2 mt-2"></v-divider>
              <v-row class="px-2">
                <v-col>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                  </p>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.BUY_QUANTITY
                      }}</span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ item.BUY_RATE
                      }}</span>
                  </p>
                </v-col>
                <v-col class="text-end">
                  <p v-if="item.NET_AMOUNT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                    {{ item.NET_AMOUNT }}</p>

                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_QUANTITY }}

                    </span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_RATE
                      }}</span>
                  </p>
                </v-col>
              </v-row> -->
            <!-- </v-card> -->
            <v-card v-if="dessertsexpandderivative.length == 0 && loader == false"
              style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;" class="elevation-0  px-4"
              width="100%">
              <v-row class="px-2">
                <v-col class="mx-auto text-center my-4">
                  <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                  <p class="font-weight-bold black--text">No data available</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card v-if="loader" style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;"
              class="elevation-0  px-4" width="100%">
              <v-row class="px-2 ">
                <v-col class="mx-auto text-center my-10">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <!-- <v-card v-for="item in dessertsexpand " :key="item.index" style="border-top: 5px #F1F3F8 solid;"
              class="elevation-0  px-4 pt-2" width="100%"> -->

            <!-- <span @click="detailedpopmobile(item)" class="font-weight-bold">

           

                <span>{{ item.name }}<v-icon color="#0037B7">mdi
                    mdi-menu-right</v-icon></span>
             
              </span> -->
            <v-expansion-panels inset style="z-index: 0">

              <v-expansion-panel v-for="(item, i) in dessertsexpandcommodity" :key="i">
                <v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card v-for="iitem in item.val" :key="iitem.index" style="border-top: 5px #F1F3F8 solid;"
                    class="elevation-0  px-4 pt-2" width="100%">

                    <span class="font-weight-bold">

                      {{ iitem.SCRIP_SYMBOL }}

                      <!-- {{ item.COMPANY_CODE }} -->
                      <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                    </span>
                    <v-divider class="mb-2 mt-2"></v-divider>
                    <v-row class="px-2">
                      <v-col>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                        </p>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.BUYQTY
                            }}</span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ iitem.BUYRATE
                            }}</span>
                        </p>
                      </v-col>
                      <v-col class="text-end">
                        <p v-if="iitem.NETAMT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                          {{ iitem.NETAMT }}</p>

                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALEQTY }}

                          </span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALERATE
                            }}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-divider class="mb-2 mt-2"></v-divider>
              <v-row class="px-2">
                <v-col>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                  </p>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.BUY_QUANTITY
                      }}</span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ item.BUY_RATE
                      }}</span>
                  </p>
                </v-col>
                <v-col class="text-end">
                  <p v-if="item.NET_AMOUNT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                    {{ item.NET_AMOUNT }}</p>

                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_QUANTITY }}

                    </span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_RATE
                      }}</span>
                  </p>
                </v-col>
              </v-row> -->
            <!-- </v-card> -->
            <v-card v-if="dessertsexpandcommodity.length == 0 && loader == false"
              style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;" class="elevation-0  px-4"
              width="100%">
              <v-row class="px-2">
                <v-col class="mx-auto text-center my-4">
                  <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                  <p class="font-weight-bold black--text">No data available</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card v-if="loader" style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;"
              class="elevation-0  px-4" width="100%">
              <v-row class="px-2 ">
                <v-col class="mx-auto text-center my-10">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <!-- <v-card v-for="item in dessertsexpand " :key="item.index" style="border-top: 5px #F1F3F8 solid;"
              class="elevation-0  px-4 pt-2" width="100%"> -->

            <!-- <span @click="detailedpopmobile(item)" class="font-weight-bold">

           

                <span>{{ item.name }}<v-icon color="#0037B7">mdi
                    mdi-menu-right</v-icon></span>
             
              </span> -->
            <v-expansion-panels inset style="z-index: 0">

              <v-expansion-panel v-for="(item, i) in dessertsexpandcurrency" :key="i">
                <v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card v-for="iitem in item.val" :key="iitem.index" style="border-top: 5px #F1F3F8 solid;"
                    class="elevation-0  px-4 pt-2" width="100%">

                    <span class="font-weight-bold">

                      {{ iitem.SCRIP_SYMBOL }}

                      <!-- {{ item.COMPANY_CODE }} -->
                      <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                    </span>
                    <v-divider class="mb-2 mt-2"></v-divider>
                    <v-row class="px-2">
                      <v-col>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                        </p>
                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.BUYQTY
                            }}</span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ iitem.BUYRATE
                            }}</span>
                        </p>
                      </v-col>
                      <v-col class="text-end">
                        <p v-if="iitem.NETAMT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                          iitem.NETAMT }}</p>
                        <p v-if="iitem.NETAMT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                          {{ iitem.NETAMT }}</p>

                        <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALEQTY }}

                          </span>
                        </p>
                        <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                              iitem.SALERATE
                            }}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-divider class="mb-2 mt-2"></v-divider>
              <v-row class="px-2">
                <v-col>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Amount
                  </p>
                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.BUY_QUANTITY
                      }}</span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{ item.BUY_RATE
                      }}</span>
                  </p>
                </v-col>
                <v-col class="text-end">
                  <p v-if="item.NET_AMOUNT > 0" class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT < 0" class="mb-0 body-2 font-weight-regular" style="color: red;">{{
                    item.NET_AMOUNT }}</p>
                  <p v-if="item.NET_AMOUNT == 0" class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                    {{ item.NET_AMOUNT }}</p>

                  <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Quantity: <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_QUANTITY }}

                    </span>
                  </p>
                  <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                      class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                        item.SALE_RATE
                      }}</span>
                  </p>
                </v-col>
              </v-row> -->
            <!-- </v-card> -->
            <v-card v-if="dessertsexpandcurrency.length == 0 && loader == false"
              style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;" class="elevation-0  px-4"
              width="100%">
              <v-row class="px-2">
                <v-col class="mx-auto text-center my-4">
                  <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%" height="" />
                  <p class="font-weight-bold black--text">No data available</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card v-if="loader" style="border-top: 5px #F1F3F8 solid; border-bottom: 5px #F1F3F8 solid ;"
              class="elevation-0  px-4" width="100%">
              <v-row class="px-2 ">
                <v-col class="mx-auto text-center my-10">
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>


      </div>
    </v-container>
  </v-app>
</template>

<script>
// import CalendarProfitlose from '@/views/heatmap calendars/CalendarProfitlose.vue';
import { apiurl } from '../../../Api.js'
import exportFromJSON from "export-from-json";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"
import zebupdfImage from '../../../assets/zebupdf.png';
// import ExcelJS from 'exceljs';
import imagePath from '@/assets/zebulogo.svg';

// import axios from 'axios';
export default {
  data() {
    return {
    fromDate:null,
    toDate:null,
    fromMenu:false,
    toMenu:false,
    downpdfrexel:"",
    selectedDownloadType:null,
    showDownloadDialog:false,
    openDownloadDialog:false,
    isloading:false,
      show: false,
      othersdbcr: 0,
      longnetval: 0,
      newstat: {},
      newinnervaluestat: {},
      eqarr: [],
      comothersdbcr: 0,
      downloadarray: [],
      curothersdbcr: 0,
      derothersdbcr: 0,
      opturnover: 0,
      futurnover: 0,
      derclsed: 0,
      futopened: 0,
      optioncls: 0,
      optionopn: 0,
      tradenetamt: 0,
      newpopupstat: false,
      stnetamt: 0,
      assnetamt: 0,
      statequity: [
        {
          name: 'Trade P&L',
          val: ''
        },
        {
          name: 'TradeTurnover',
          val: ''
        },
        {
          name: 'Short Term Realized P&L',
          val: ''
        },
        {
          name: 'Long Term Realized P&L',
          val: ''
        },
        {
          name: 'Total Chanrges',
          val: ''
        },
        {
          name: 'Other credits/debits',
          val: ''
        },

      ],
      downloadarrayForPdf: [],
      chararr: [],
      statderivate: [
        {
          name: 'Futures P&L',
          val: ''
        },
        {
          name: 'Futures Turnover',
          val: ''
        },
        {
          name: 'Options P&L',
          val: ''
        },
        {
          name: 'Oprions Turnover',
          val: ''
        },
        {
          name: 'Total Charges',
          val: ''
        },
        {
          name: 'Other credits/debits',
          val: ''
        },
        {
          name: 'Total Gross Profit',
          val: ''
        },

      ],
      statcommo: [
        {
          name: 'Futures P&L',
          val: ''
        },
        {
          name: 'Futures Turnover',
          val: ''
        },
        {
          name: 'Options P&L',
          val: ''
        },
        {
          name: 'Oprions Turnover',
          val: ''
        },
        {
          name: 'Total Charges',
          val: ''
        },
        {
          name: 'Other credits/debits',
          val: ''
        },
        {
          name: 'Total Gross Profit',
          val: ''
        },

      ],
      statcurr: [
        {
          name: 'Futures P&L',
          val: ''
        },
        {
          name: 'Futures Turnover',
          val: ''
        },
        {
          name: 'Options P&L',
          val: ''
        },
        {
          name: 'Oprions Turnover',
          val: ''
        },
        {
          name: 'Total Charges',
          val: ''
        },
        {
          name: 'Other credits/debits',
          val: ''
        },
        {
          name: 'Total Gross Profit',
          val: ''
        },

      ],
      menu2: false,

      dessertsdummy: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1,
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1,
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7,
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: 8,
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: 16,
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: 0,
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: 2,
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: 45,
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: 22,
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: 6,
        },
      ],
      expanded: [],
      expandedder: [],
      expandedcom: [],
      expandedcur: [],
      downbtn: true,
      expandedinner: [],
      singleExpand: false,
      dessertsexpandinner: [],
      tab1: null,
      tab2: null,
      tab3: null,
      tab4: null,
      tab5: null,
      segloader: false,
      disdowbtn: true,
      dessertHeaders: [
        {
          text: 'Symbol',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '28%'

        },
        { text: 'Buy Qty', value: '', align: 'right', width: '9%' },
        { text: 'Buy Rate', value: '', width: '9%', align: 'right' },
        { text: 'Sell Qty', value: '', width: '9%', align: 'right' },
        { text: 'Sell Rate', value: '', width: '9%', align: 'right' },
        { text: 'Net Qty', value: '', width: '9%', align: 'right' },
        { text: 'Net Rate', value: '', width: '9%', align: 'right' },
        { text: 'Close price', value: '', width: '9%', align: 'right' },
        { text: 'P & L', value: '', width: '15%', align: 'right' },
        { text: '', value: 'data-table-expand' },
      ],
      headersexpandinside: [
        {
          text: 'Symbol',
          align: 'start',
          sortable: false,
          value: 'SCRIP_NAMEDATA',
          width: '30%'
        },

        // { text: 'Net Amount', value: 'NETAMT' },

        { text: 'Buy Qty', value: 'BUY_QTY', sortable: false, align: 'right' },
        { text: 'Buy Rate', value: 'BUY_RATE', sortable: false, align: 'right' },
        // { text: 'Buy Amount', value: 'BAMT' },
        { text: 'Sell Qty', value: 'SALE_QTY', sortable: false, align: 'right' },
        { text: 'Sell Rate', value: 'SALE_RATE', sortable: false, align: 'right' },

        { text: 'Net Qty', value: 'NET_QTY', sortable: false, align: 'right' },
        { text: 'Net Rate', value: 'NET_RATE', sortable: false, align: 'right' },
        // { text: 'Sell Amount', value: 'SAMT' },
        { text: 'Close price', value: 'Closing_Price', sortable: false, align: 'right' },
        // { text: 'Current Value', value: 'CURR_AMOUNT', sortable: false, align: 'right' },
        { text: 'P&l', value: 'NOTIONAL_NET', align: 'right' },
        { text: '', value: 'data-table-expand' },

        // { text: 'P & L', value: '' },
        // { text: '', value: 'data-table-expand' },
      ],
      headersexpandinsidecom: [
        {
          text: 'Symbol',
          align: 'start',
          sortable: false,
          value: 'SCRIP_SYMBOL',
          width: '15%'
        },

        // { text: 'Net Amount', value: 'NETAMT' },

        { text: 'Buy Qty', value: 'BUYQTY', sortable: false, align: 'right' },
        { text: 'Buy Rate', value: 'BUYRATE', sortable: false, align: 'right' },
        // { text: 'Buy Amount', value: 'BAMT' },
        { text: 'Sell Qty', value: 'SALEQTY', sortable: false, align: 'right' },
        { text: 'Sell Rate', value: 'SALERATE', sortable: false, align: 'right' },

        { text: 'Net Qty', value: 'NETQTY', sortable: false, align: 'right' },
        { text: 'Net Rate', value: 'NETRATE', sortable: false, align: 'right' },
        // { text: 'Sell Amount', value: 'SAMT' },
        { text: 'Close price', value: 'CL_PRICE', sortable: false, align: 'right' },
        // { text: 'Current Value', value: 'CURR_AMOUNT', sortable: false, align: 'right' },
        { text: 'P&l', value: 'NOTIONAL_NET', align: 'right' },
        { text: '', value: 'data-table-expand' },

        // { text: 'P & L', value: '' },
        // { text: '', value: 'data-table-expand' },
      ],
      items: [
      ],
      yearis: '',
      dessertsexpand: [],
      dessertsexpandderivative: [],
      eqloader: false,
      dessertsexpandcommodity: [],
      dessertsexpandcurrency: [],

      dialogmobile: false,
      summary: true,
      radios: null,
      radios1: null,
      inject: {
        theme: {
          default: { isDark: false },
        },
      },
      itemss: [

      ],
      search: '',
      itemperpageinexpandinner: 0,
      searchde: '',
      // expanded: [],
      more: true,
      less: false, more1: true,
      less1: false,
      itemperpage: 8,
      msg: '',

      alert: false,

      sheet: false,
      sheet1: false,
      itemperpage1: 8,
      loader: true,
      headerval: [],
      dialog: false,
      detailedpoparray: [],
      tables: [

        // Add more tables as needed
      ],
      yearindex: "",
      search1: '',
      tabvaluestack: 'Equities',
      itemperpage1inner: 0,
      // tab: null,
      // yearfromdown: ["2018", "2019", "2020", "2021", "2022", "2023"],
      desserts: [],
      dessertsoriginal: [],
      scriptname: '',
      dessertspop: [],
      dessertspopexpense: [],
      disabletabsexpense: true,
      totalintraday: 0,
      desserts2: [],
      newstateq: [],
      sortBy: 'SCRIP_NAME',
      dates: [""],
      filterr: [
        "All", "Equities", "Future & Options", "Commodities", "Currencies"
      ],
      filterdata_unpl: 'All',
      filterdata_unpl1: 'All',
      itemsdwl: [
        {
          title: 'Download Excel',
        },
        {
          title: 'Download Pdf',
        },
      ],
      Overviewheaders2: [
        { text: "Trade Date", value: "TRADE_DATE", width: "10%", class: "headerfont" },

        // { text: "Symbol", value: "SCRIP_NAME", width: "20%", class: "headerfont" },


        { text: 'Buy Qty', value: 'BQTY', align: "end", class: "headerfont", width: "10%" },
        { text: 'Buy Rate', value: 'BRATE', align: "end", class: "headerfont", width: "10%" },
        // { text: 'Buy Amt', value: 'BAMT', align: "end" },
        { text: 'Sell Qty', value: 'SQTY', align: "end", class: "headerfont", width: "10%" },
        { text: 'Sell Rate', value: 'SRATE', align: "end", class: "headerfont", width: "10%" },
        // { text: 'Sale Amt', value: 'SAMT', align: "end" },
        { text: 'Net Qty', value: 'NETQTY', align: "end", class: "headerfont", width: "10%" },
        { text: 'Net Rate', value: 'NRATE', align: "end", class: "headerfont", width: "10%" },
        // { text: 'NET Amt', value: 'NETAMT', align: "end" },
        // { text: 'Closing Price', value: 'CLSPR', align: "end", class: "headerfont" },
        { text: 'P & L', value: 'PRO', align: "end", class: "headerfont", width: "10%" },


      ],
      finaltotal: 0,
      profiledetails: [],
      cname: '',
      Overviewheaders: [
        { text: "Symbol", value: "SCRIP_SYMBOL", class: "headerfont" },
        // { text: '', value: 'data-table-expand', class: "headerfont" },
        // { text: "Trading Quantity", value: "TRADING_QUANTITY" , align: 'end'},
        // { text: "Trading Amt", value: "TRADING_AMOUNT" , align: 'end'},
        { text: "Buy Qty", value: "BUY_QUANTITY", align: "end", class: "headerfont" },
        { text: "Buy Rate", value: "BUY_RATE", align: "end", class: "headerfont" },
        // { text: "BAmt", value: "BUY_AMOUNT", align: "end", class: "headerfont" },
        { text: "Sell Qty", value: "SALE_QUANTITY", align: "end", class: "headerfont" },
        { text: "Sell Rate", value: "SALE_RATE", align: "end", class: "headerfont" },
        // { text: "SAmt", value: "SALE_AMOUNT", align: "end", class: "headerfont" },
        { text: "Net Qty", value: "NET_QUANTITY", align: "end", class: "headerfont" },
        { text: "Net Rate", value: "NET_RATE", align: "end", class: "headerfont" },
        { text: "Close price", value: "CLOSING_PRICE", align: "end", class: "headerfont" },
        // { text: "NAmt", value: "NET_AMOUNT", align: "end", class: "headerfont" },
        // { text: "Closing Price", value: "CLOSING_PRICE", align: "end", class: "headerfont" },
        { text: "P & L", value: "NOT_PROFIT", align: "end", class: "headerfont" },
      ],
      Overviewheadersder: [
        { text: "Symbol", value: "SCRIP_SYMBOL", class: "headerfont" },
        // { text: '', value: 'data-table-expand', class: "headerfont" },
        // { text: "Trading Quantity", value: "TRADING_QUANTITY" , align: 'end'},
        // { text: "Trading Amt", value: "TRADING_AMOUNT" , align: 'end'},
        { text: "Buy Qty", value: "BUY_QUANTITY", align: "end", class: "headerfont" },
        { text: "Buy Rate", value: "BUY_RATE", align: "end", class: "headerfont" },
        // { text: "BAmt", value: "BUY_AMOUNT", align: "end", class: "headerfont" },
        { text: "Sell Qty", value: "SALE_QUANTITY", align: "end", class: "headerfont" },
        { text: "Sell Rate", value: "SALE_RATE", align: "end", class: "headerfont" },
        // { text: "SAmt", value: "SALE_AMOUNT", align: "end", class: "headerfont" },
        { text: "Net Qty", value: "NET_QUANTITY", align: "end", class: "headerfont" },
        { text: "Net Rate", value: "NET_RATE", align: "end", class: "headerfont" },
        { text: "Close price", value: "CLOSING_PRICE", align: "end", class: "headerfont" },
        // { text: "NAmt", value: "NET_AMOUNT", align: "end", class: "headerfont" },
        // { text: "Closing Price", value: "CLOSING_PRICE", align: "end", class: "headerfont" },
        { text: "P & L", value: "NOT_PROFIT", align: "end", class: "headerfont" },
      ],
      tab: null,
      // items: [
      //   'Summary', 'Detailed',
      // ],
      desserts23: [],
      detpop: [],
      actid: '',
      susertoken: '',
      keyyy: '',
      downsum: true,
      disrealised_pnl: '',
      disunrealised_pnl: '',
      year: '',
      dessertstaxdis: [],
      disabletabs: true,
      fromdate: '',
      fromdateapi: '',
      headersBifurcation: [
        { text: "Particulars", value: "name", class: "headerfont", align: "start" },
        { text: "", value: "value", class: "headerfont", align: "end" },
      ],
      fromshow: '',
      toshow: '',
      todate: '',
      comnetamt: 0,
      comturnover: 0,
      futturnover: 0,
      comnetfutamt: 0,
      derchargers: 0,
      comchargers: 0,
      curchargers: 0,
      segval: 0,
      curfutturnover: 0,
      curopnetamt: 0,
      comopturnover: 0,
      curnetfutamt: 0,
      imageBase64: null,
      snackbar:false,
      textsnac:""
      // intraday: 0,
    };
  },
  // components: { CalendarProfitlose },
  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    filteredDesserts() {
      const searchTerm = this.search.toLowerCase();
      return this.dessertsoriginal.filter(item => item.SCRIP_SYMBOL.toLowerCase().includes(searchTerm));
    },
    filteredDesserts1() {
      const searchTerm = this.searchde.toLowerCase();
      return this.desserts23.filter(item => item.SCRIP_SYMBOL.toLowerCase().includes(searchTerm));
    },
  },
 methods: {
    // openDownloadDialog(type) {
    // // Normalize selected type to 'excel' or 'pdf'
    // this.selectedDownloadType = (type.toLowerCase().includes('excel') ? 'excel' : 'pdf');
    // this.showDownloadDialog = true;
  
  apiexcelcl(){
    this.isloading = true;
   this.snackbar = true 
  this.textsnac = this.downpdfrexel == 'Download Excel' ? 'Excel download is processing' : 'PDF download is processing'

 const axios = require('axios');
 let data = JSON.stringify({
  "client_code": localStorage.getItem("userid"),
  "from_date":  this.fromdateapi,
  "to_date": this.toshow
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url:  this.downpdfrexel == 'Download Excel' ? "https://rekycbe.mynt.in/report/tax_p_l_excel" :   "https://rekycbe.mynt.in/report/taxpnl_pdf",


  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};
var axiosthis = this
axios.request(config)
.then((response) => {
  axiosthis.snackbar = false
  // console.log(JSON.stringify(response.data));

// .catch((error) => {
//   console.log(error);
// });
if( response.data.stat == 'Ok'){
  // let fullpath = "/home/ubuntu/Backoffice_report/static/taxpnl_excel/Tax_P&L_ZP00285_01_09_2025_22_09_2025.xlsx";
  

  if( this.downpdfrexel == 'Download Excel'){
let parts = response.data.filepath.split("/static");
  
  
  let relativepath = "/static" + parts[1]; 
  
  let finalUrl = "https://rekycbe.mynt.in/report" +  relativepath;
  console.log(finalUrl);
  window.location.href = finalUrl;
    axiosthis.alert = true 
  axiosthis.msg = 'Excel send to your mail'
  


  }else{

  
  let finalUrl = "https://rekycbe.mynt.in/report/" +  response.data.filepath;
  window.open(finalUrl, '_blank');
    axiosthis.alert = true 
  axiosthis.msg = 'Pdf send to your mail'

  }
  
  

  // window.location.href = finalUrl;

console.log("file downloaded");
}
// else{
//   console.log("file not downloaded")
//   axiosthis.alert = true 

//     axiosthis.msg = response.data.msg
// console.log("problem");
    
// }
 axiosthis.showDownloadDialog = false; 
 axiosthis.isloading=false;

})

  },
      dataBifurcation() {
      var eqarraydata = [];
      var commarray = [];
      var derivarray = [];
      var currarray = [];
      if (this.tab == 0) {
        eqarraydata.push(
          {
            name: "EQUITY DELIVERY SELL",
            value: (this.newinnervaluestat.delivery_sell || 0).toFixed(2)
          }
        )
        eqarraydata.push(
          {
            name: "EQUITY DELIVERY BUY",
            value: `- ${ (this.newinnervaluestat.delivery_buy || 0).toFixed(2)}`
          }
        )
        eqarraydata.push(
          {
            name: "EQUITY TRADING",
            value: (this.newinnervaluestat.trading || 0).toFixed(2)
          }
        )
        if (this.eqarr.length > 0) {
          this.eqarr.forEach(element => {
            eqarraydata.push({
              name: element.SCRIP_SYMBOL,
              value: element.NOT_PROFIT.toFixed(2)
            });
          });
        }
        eqarraydata.push(
          {
            name: "Total",
            value: ((this.newinnervaluestat.trading || 0) +
              (this.newinnervaluestat.delivery_sell ?? 0) -
              (this.newinnervaluestat.delivery_buy ?? 0) +
              (this.segval ?? 0)).toFixed(2)
          }
        )
        return eqarraydata
      } else if (this.tab == 1) {
        derivarray.push(
          {
            name: "BOOKED POSITION",
            value: (this.newinnervaluestat.der_total_booked || 0).toFixed(2)
          }
        )
        derivarray.push(
          {
            name: "FUTURE OPEN POSIITON",
            value: (this.newinnervaluestat.der_fut_open_val || 0).toFixed(2)
          }
        )
        derivarray.push(
          {
            name: "OPTION SELL OPEN POSITION ",
            value: (this.newinnervaluestat.der_se_open  || 0).toFixed(2)
          }
        )
        derivarray.push(
          {
            name: "OPTION OPEN BUY POSITION ",
            value: (this.newinnervaluestat.der_bu_open || 0).toFixed(2)
          }
        )
        if (this.chararr?.der_charges?.length > 0) {
          this.chararr.der_charges.forEach(element => {
            derivarray.push({
              name: element.SCRIP_SYMBOL,
              value: element.NETAMT.toFixed(2)
            });
          });
        }
        derivarray.push(
          {
            name: "REVERSED OPTION SELL OPEN POSITION",
            value: `- ${(this.newinnervaluestat?.der_se_open ?? 0).toFixed(2)}`
          }
        )
        derivarray.push(
          {
            name: "Total",
            value: (this.newinnervaluestat?.der_total_value ?? 0).toFixed(2)
          }
        )
        return derivarray
      } else if (this.tab == 2) {
        commarray.push(
          {
            name: "BOOKED POSITION",
            value: (this.newinnervaluestat.com_total_booked || 0).toFixed(2)
          }
        )
        commarray.push(
          {
            name: "FUTURE OPEN POSIITON",
            value: (this.newinnervaluestat.com_fut_open_val || 0).toFixed(2)
          }
        )
        commarray.push(
          {
            name: "OPTION SELL OPEN POSITION ",
            value: (this.newinnervaluestat.com_se_open || 0).toFixed(2)
          }
        )
        commarray.push(
          {
            name: "OPTION OPEN BUY POSITION ",
            value: (this.newinnervaluestat.com_bu_open || 0).toFixed(2)
          }
        )
        if (this.chararr?.comm_charges?.length > 0) {

          this.chararr.comm_charges.forEach(element => {
            commarray.push({
              name: element.SCRIP_SYMBOL,
              value: element.NETAMT
            });
          });
        }
        commarray.push(
          {
            name: "REVERSED OPTION SELL OPEN POSITION ",
            value: `- ${(this.newinnervaluestat?.com_se_open ?? 0).toFixed(2)}`
          }
        )
        commarray.push(
          {
            name: "Total",
            value: (this.newinnervaluestat?.com_total_value ?? 0).toFixed(2)
          }
        )

        return commarray
      } else if (this.tab == 3) {
        currarray.push(
          {
            name: "BOOKED POSITION",
            value: (this.newinnervaluestat.curr_total_booked || 0).toFixed(2)
          }
        )
        currarray.push(
          {
            name: "FUTURE OPEN POSIITON",
            value: (this.newinnervaluestat.curr_fut_open_val || 0).toFixed(2)
          }
        )
        currarray.push(
          {
            name: "OPTION SELL OPEN POSITION ",
            value: (this.newinnervaluestat.curr_se_open || 0).toFixed(2)
          }
        )
        currarray.push(
          {
            name: "OPTION OPEN BUY POSITION ",
            value: (this.newinnervaluestat.curr_bu_open || 0).toFixed(2)
          }
        )
        if (this.chararr?.cur_charges?.length > 0) {
          this.chararr.cur_charges.forEach(element => {
            currarray.push({
              name: element.SCRIP_SYMBOL,
              value: element.NETAMT.toFixed(2)
            });
          });
        }
        currarray.push(
          {
            name: "REVERSED OPTION SELL OPEN POSITION ",
            value: `- ${(this.newinnervaluestat?.curr_se_open ?? 0).toFixed(2)}`
          }
        )
        currarray.push(
          {
            name: "Total",
            value: (this.newinnervaluestat?.curr_total_value ?? 0).toFixed(2)
          }
        )
        return currarray
      }



    },
    opendetailstat(item, num) {
      this.tab = num
      this.newpopupstat = true
      this.newinnervaluestat = item
      if (num == 0) {
        this.headersBifurcation[1].text = 'Equity'
      } else if (num == 1) {
        this.headersBifurcation[1].text = 'Derivative'
      } else if (num == 2) {
        this.headersBifurcation[1].text = 'Commodity'
      } else if (num == 3) {
        this.headersBifurcation[1].text = 'Currecncy'
      }

    },
    decryptionFunction(payld) {
      var CryptoJS = require("crypto-js");

      const payload = payld;
      const derived_key = CryptoJS.enc.Base64.parse(btoa("N#j2L^8pq9Fb$d@1")); //YXNkZmdoamtsenhjdmJubQ==
      const iv = CryptoJS.enc.Utf8.parse("3790514682037125");
      const encryptedData = payload;

      // Decrypt the data using AES
      const decrypted = CryptoJS.AES.decrypt(encryptedData, derived_key, {
        iv,
        mode: CryptoJS.mode.CBC,
      });
      const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);

      // // console.log('Decrypted Data:', decryptedData);
      return decryptedData;
    },

    convertImageToBase64() {

      fetch(imagePath)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.imageBase64 = reader.result;
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) => {
          console.error('Error loading local image:', error);
        });
    },




    valdwl(item) {
      this.sheet1 = false

      let data = item






      var eqarray = [
        {
          name: "EQUITY TRADING / BOOKED POSITION",
          value: this.newstateq.trading?.toFixed(2) ?? 0,
          value2: this.newstat?.der_total?.der_total_booked?.toFixed(2) ?? 0,
          value3: this.newstat?.com_total?.com_total_booked?.toFixed(2) ?? 0,
          value4: this.newstat?.curr_total?.curr_total_booked?.toFixed(2) ?? 0,
        },
        {
          name: "EQUITY DELIVERY BUY / FUTURE OPEN POSIITON",
          value:` -${ this.newstateq.delivery_buy?.toFixed(2) ?? 0}`,
          value2: this.newstat?.der_total?.der_fut_open_val?.toFixed(2) ?? 0,
          value3: this.newstat?.com_total?.com_fut_open_val?.toFixed(2) ?? 0,
          value4: this.newstat?.curr_total?.curr_fut_open_val?.toFixed(2) ?? 0,
        },
        {
          name: "EQUITY DELIVERY SELL / OPTION SELL OPEN POSITION",
          value: this.newstateq.delivery_sell?.toFixed(2) ?? 0,
          value2: this.newstat?.der_total?.der_se_open?.toFixed(2) ?? 0,
          value3: this.newstat?.com_total?.com_se_open?.toFixed(2) ?? 0,
          value4: this.newstat?.curr_total?.curr_se_open?.toFixed(2) ?? 0,
        },
        {
          name: "OPTION OPEN BUY POSITION",
          value: 0,
          value2: this.newstat?.der_total?.der_bu_open?.toFixed(2) ?? 0,
          value3: this.newstat?.com_total?.com_bu_open?.toFixed(2) ?? 0,
          value4: this.newstat?.curr_total?.curr_bu_open?.toFixed(2) ?? 0,
        },
        ...["STT", "CTT", "TOT", "TOC NSE EXCHANGE","TOC BSE EXCHANGE", "SEBITOC", "CMCHARGES", "STAMP DUTY", "IGST"].map(name => ({
          name,
          value: 0,
          value2: 0,
          value3: 0,
          value4: 0
        })),
        {
          name: "REVERSED OPTION SELL OPEN POSITION",
          value: 0,
          value2: `- ${(this.newstat?.der_total?.der_se_open ?? 0).toFixed(2)}`,
          value3: `-${(this.newstat?.com_total?.com_se_open ?? 0).toFixed(2)}`,
          value4: `- ${(this.newstat?.curr_total?.curr_se_open ?? 0).toFixed(2)}`
        },
        {
          name: "TOTAL VALUE",
          value: ((this.newstateq.trading ?? 0) +
            (this.newstateq.delivery_sell ?? 0) -
            (this.newstateq.delivery_buy ?? 0) +
            (this.segval ?? 0)).toFixed(2),
          value2: (this.newstat?.der_total?.der_total_value ?? 0).toFixed(2),
          value3:  (this.newstat?.com_total?.com_total_value ?? 0).toFixed(2),
          value4:  (this.newstat?.curr_total?.curr_total_value ?? 0).toFixed(2)
        }
      ];
    
      // Common function to update value fields from charges
      const applyCharges = (charges, key) => {
        charges?.forEach(charge => {
          const symval = charge.FULL_SCRIP_SYMBOL?.replaceAll("*", "").toUpperCase();
          // console.log(symval);
          
          eqarray.forEach(row => {
            if (row.name.toUpperCase() == (symval)) {
              row[key] = charge.NETAMT;
            }
          });
        });
      };

      // Apply eqarr profits
      this.eqarr?.forEach(item => {
        eqarray.forEach(row => {
          if (row.name.includes(item.SCRIP_SYMBOL.toUpperCase())) {
            row.value = item.NOT_PROFIT;
          }
        });
      });

      // Apply charge-based values
      applyCharges(this.chararr?.der_charges, 'value2');
      applyCharges(this.chararr?.comm_charges, 'value3');
      applyCharges(this.chararr?.cur_charges, 'value4');

console.log("test downnn");
        


      if (data === "Download Excel") {

        this.downpdfrexel = data
        this.apiexcelcl()
                // this.showDownloadDialog = true; 
               

//         if (!this.imageBase64) {
//           alert('Excel Download error');
//           return;
//         }

//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet('TAX P&L');
//         const equitySheet = workbook.addWorksheet('Equity');
//         const devisheet = workbook.addWorksheet('Derivatives');
//         const commsheet = workbook.addWorksheet('Commodity');
//         const currsheet = workbook.addWorksheet('Currency');




//         // Combine tables and add rows
//         const combinedTables = this.tables.reduce((acc, current) => {
//           let existingTable = acc.find(table => table.heading === current.heading);
//           if (existingTable) {
//             existingTable.data = existingTable.data.concat(current.data);
//           } else {
//             acc.push({
//               heading: current.heading,
//               data: current.data
//             });
//           }
//           return acc;
//         }, []);

//         let rows = [];
//         let headingRowNumbers = {}; // To store row numbers of specific headings

//         combinedTables.forEach(table => {
//           const heading = table.heading;
//           const tableData = table.data;

//           // Add table heading
//           rows.push([heading]);
//           headingRowNumbers[heading] = rows.length; // Store row number for merging

//           // Add header row (if it exists)
//           if (tableData.length > 0) {
//             rows.push(tableData[0]);

//             // Add data rows (excluding the header row)
//             for (let i = 1; i < tableData.length; i++) {
//               rows.push(tableData[i]);
//             }
//           }
//           rows.push([]); // Add a blank row between tables
//         });

//         // Fill the main sheet
//         const headerRows = [
//           ["", "Tax P&L", "Client ID", this.actid],
//           ["", "", "Client Name", this.cname],
//           ["", "", "Client PAN", this.profiledetails['PAN_NO']],
//           ["", "", "Client Email-Id", this.profiledetails['CLIENT_ID_MAIL']],
//           [],
//           // ['Equities', 'Derivatives', 'Commodity', 'Currency'],
//           // [`Long Term Realized P&L : ${(this.longnetval).toFixed(2)}`, `Futures P&L : ${(this.futopened).toFixed(2)}`, `Futures P&L : ${(this.comnetfutamt).toFixed(2)}`, `Futures P&L : ${(this.curnetfutamt).toFixed(2)}`],
//           // [`Short Term Realized P&L : ${(this.stnetamt).toFixed(2)}`, `Futures Turnover : ${(this.futurnover).toFixed(2)}`, `Futures Turnover : ${(this.futturnover).toFixed(2)}`, `Futures Turnover  : ${(this.curfutturnover).toFixed(2)}`],
//           // [`Trading P&L : ${(this.tradenetamt).toFixed(2)}`, `Options P&L : ${(this.optionopn).toFixed(2)}`, `Options P&L : ${(this.comnetamt).toFixed(2)}`, `Options P&L : ${(this.curopnetamt).toFixed(2)}`],
//           // [`Assets P&L : ${(this.assnetamt).toFixed(2)}`, `Options Turnover : ${(this.opturnover).toFixed(2)}`, `Options Turnover : ${(this.comturnover).toFixed(2)}`, `Options Turnover : ${(this.comopturnover).toFixed(2)}`],
//           // [`Trading Turnover : ${(this.totalintraday).toFixed(2)}`, `Total Charges ${(this.derchargers).toFixed(2)}`, `Total Charges : ${(this.comchargers).toFixed(2)}`, `Total Charges : ${(this.curchargers).toFixed(2)}`],
//           // [`Total Charges : ${(this.segval).toFixed(2)}`],
//           // [],
//           ['Bifurcation of Bill'],
//           ['Particulars', 'Equity', 'Derivative', 'Commodity ', 'Currency '],
//           []
//         ];


//         let equityRows = [];
//         let derivativeRows = [];
//         let commodityRows = [];
//         let currencyRows = [];

//         if (this.eqarr && Array.isArray(this.eqarr)) {
//           equityRows.push(['Equities Charges']);
//           equityRows.push(["Symbol", "Net Amount"]);
//           this.eqarr.forEach(element => {
//             equityRows.push([element.SCRIP_SYMBOL, element.NOT_PROFIT]);
//           });
//           equityRows.push([]);
//         }

//         if (this.chararr && this.chararr.der_charges && Array.isArray(this.chararr.der_charges)) {
//           derivativeRows.push(['Derivative Charges']);
//           derivativeRows.push(["Symbol", "Net Amount"]);
//           this.chararr.der_charges.forEach(element => {
//             derivativeRows.push([element.SCRIP_SYMBOL, element.NETAMT]);
//           });
//           derivativeRows.push([]);
//         }

//         if (this.chararr && this.chararr.comm_charges && Array.isArray(this.chararr.comm_charges)) {
//           commodityRows.push(['Commodity Charges']);
//           commodityRows.push(["Symbol", "Net Amount"]);
//           this.chararr.comm_charges.forEach(element => {
//             commodityRows.push([element.SCRIP_SYMBOL, element.NETAMT]);
//           });
//           commodityRows.push([]);
//         }

//         if (this.chararr && this.chararr.cur_charges && Array.isArray(this.chararr.cur_charges)) {
//           currencyRows.push(['Currency Charges']);
//           currencyRows.push(["Symbol", "Net Amount"]);
//           this.chararr.cur_charges.forEach(element => {
//             currencyRows.push([element.SCRIP_SYMBOL, element.NETAMT]);
//           });
//           currencyRows.push([]);
//         }
//         const eqarrayRowss = eqarray.map(item => [
//   item.name,
//   item.value,
//   item.value2,
//   item.value3,
//   item.value4
// ]);


//        let allRows = headerRows
//   .concat(eqarrayRowss) 
//   .concat(rows);

//         const imageId = workbook.addImage({
//           base64: this.imageBase64,
//           extension: 'svg'
//         });

//         worksheet.getRow(1).height = 32.53; // Set row height to fit the image
//         worksheet.getColumn(1).width = 25; // Adjust column width to fit the image

//         worksheet.addImage(imageId, {
//           tl: { col: 0, row: 0 },
//           ext: { width: 102.53, height: 40.53 }
//         });

//         // Apply styles to the main sheet
//         allRows.forEach((row) => {
//           const excelRow = worksheet.addRow(row);
//           row.forEach((cell, cellIndex) => {
//             const cellRef = excelRow.getCell(cellIndex + 1);
//             if (cell === "") {
//               cellRef.border = {
//                 top: { style: 'none' },
//                 left: { style: 'none' },
//                 bottom: { style: 'none' },
//                 right: { style: 'none' }
//               };
//             }
//             if (['Equities Charges', 'Derivative Charges', 'Commodity Charges', 'Currency Charges', 'Commodity Option Open', 'Commodity Option Closed', 'Equities', 'Derivatives', 'Commodity', 'Currency', 'Derivative Option Open', 'Derivative Option Closed', 'Assets', 'Liabilities', 'Trading', 'ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED', 'Commodity Future Closed' , 'Bifurcation of Bill'].includes(cell)) {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 11,
//                 bold: true
//               };
//             } else if (['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L', 'Net Amount' , 'Particulars' , 'Equity' , 'Derivative' , 'Commodity ','Currency '].includes(cell)) {
//               cellRef.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F226B' } };
//               cellRef.font = { bold: true, color: { argb: 'ffffff' } };
//             }
//             cellRef.alignment = { horizontal: 'left' };
//             if (cell === "Tax P&L") {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 14,
//                 bold: true
//               };
//             }
//           });

//           // Merge cells vertically for specific rows
//           if (row[0] === "ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED") {
//             const rowNum = rows.indexOf(row) + 1; // Calculate the actual row number in the worksheet
//             worksheet.mergeCells(`A${rowNum}:A${rowNum + 1}`);
//           }
//         });

//         // Adjust column width
//         worksheet.columns.forEach((column) => {
//           let maxLength = 0;
//           column.eachCell({ includeEmpty: true }, (cell) => {
//             const cellValue = cell.value ? cell.value.toString() : '';
//             maxLength = Math.max(maxLength, cellValue.length);
//           });
//           column.width = maxLength < 10 ? 10 : maxLength + 2;
//         });

//         // Add borders to all cells
//         worksheet.eachRow({ includeEmpty: false }, (row) => {
//           row.eachCell({ includeEmpty: false }, (cell) => {
//             if (cell.value !== "") {
//               cell.border = {
//                 top: { style: 'thin' },
//                 left: { style: 'thin' },
//                 bottom: { style: 'thin' },
//                 right: { style: 'thin' }
//               };
//             }
//           });
//         });

//         // Fill and style the Equity sheet
//         equitySheet.addRow(["", "Tax P&L", "Client ID", this.actid]);
//         equitySheet.addRow(["", "", "Client Name", this.cname]);
//         equitySheet.addRow(["", "", "Client PAN", this.profiledetails['PAN_NO']]);
//         equitySheet.addRow(["", "", "Client Email-Id", this.profiledetails['CLIENT_ID_MAIL']]);
//         equitySheet.addRow([]);
//         // equitySheet.addRow(['Equities']);
//         // equitySheet.addRow([`Long Term Realized P&L : ${(this.longnetval).toFixed(2)}`]);
//         // equitySheet.addRow([`Short Term Realized P&L : ${(this.stnetamt).toFixed(2)}`]);
//         // equitySheet.addRow([`Trading P&L : ${(this.tradenetamt).toFixed(2)}`]);
//         // equitySheet.addRow([`Assets P&L : ${(this.assnetamt).toFixed(2)}`]);
//         // equitySheet.addRow([`Trading Turnover : ${(this.totalintraday).toFixed(2)}`]);
//         // equitySheet.addRow([`Total Charges : ${(this.segval).toFixed(2)}`]);

//         // equitySheet.addRow([]);

//         // if (this.eqarr && Array.isArray(this.eqarr)) {
//         //   equitySheet.addRow(['Equities Charges']);
//         //   equitySheet.addRow(["Symbol", "Net Amount"]);
//         //   this.eqarr.forEach(element => {
//         //     equitySheet.addRow([element.SCRIP_SYMBOL, element.NOT_PROFIT]);
//         //   });
//         //   equitySheet.addRow([]);
//         // }

//         // Add 'Assets' data to the Equity sheet
//         combinedTables.forEach(table => {
//           if (table.heading === 'Assets' || table.heading === 'Liabilities' || table.heading === 'Trading') {
//             equitySheet.addRow([table.heading]);
//             table.data.forEach((row) => {
//               equitySheet.addRow(row);
//             });
//             equitySheet.addRow([]);
//           }
//         });

//         equitySheet.getRow(1).height = 32.53; // Set row height to fit the image
//         equitySheet.getColumn(1).width = 35; // Adjust column width to fit the image

//         equitySheet.addImage(imageId, {
//           tl: { col: 0, row: 0 },
//           ext: { width: 102.53, height: 40.53 }
//         });

//         // Apply styles to the Equity sheet
//         equitySheet.eachRow((row) => {
//           row.eachCell((cell) => {
//             const cellRef = cell;

//             if (cell.value === "") {
//               cellRef.border = {
//                 top: { style: 'none' },
//                 left: { style: 'none' },
//                 bottom: { style: 'none' },
//                 right: { style: 'none' }
//               };
//             }
//             if (['Equities Charges', 'Derivative Charges', 'Commodity Charges', 'Currency Charges', 'Commodity Option Open', 'Commodity Option Closed', 'Equities', 'Derivatives', 'Commodity', 'Currency', 'Derivative Option Open', 'Derivative Option Closed', 'Assets', 'Liabilities', 'Trading', 'ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED', 'Commodity Future Closed'].includes(cell.value)) {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 11,
//                 bold: true
//               };
//             } else if (['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L', 'Net Amount'].includes(cell.value)) {
//               cellRef.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F226B' } };
//               cellRef.font = { bold: true, color: { argb: 'ffffff' } };
//             }
//             cellRef.alignment = { horizontal: 'left' };
//             if (cell.value === "Tax P&L") {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 14,
//                 bold: true
//               };
//             }
//           });
//         });

//         // Adjust column width
//         equitySheet.columns.forEach((column) => {
//           let maxLength = 0;
//           column.eachCell({ includeEmpty: true }, (cell) => {
//             const cellValue = cell.value ? cell.value.toString() : '';
//             maxLength = Math.max(maxLength, cellValue.length);
//           });
//           column.width = maxLength < 10 ? 10 : maxLength + 2;
//         });

//         // Add borders to all cells
//         equitySheet.eachRow({ includeEmpty: false }, (row) => {
//           row.eachCell({ includeEmpty: false }, (cell) => {
//             if (cell.value !== "") {
//               cell.border = {
//                 top: { style: 'thin' },
//                 left: { style: 'thin' },
//                 bottom: { style: 'thin' },
//                 right: { style: 'thin' }
//               };
//             }
//           });
//         });

//         devisheet.addRow(["", "Tax P&L", "Client ID", this.actid]);
//         devisheet.addRow(["", "", "Client Name", this.cname]);
//         devisheet.addRow(["", "", "Client PAN", this.profiledetails['PAN_NO']]);
//         devisheet.addRow(["", "", "Client Email-Id", this.profiledetails['CLIENT_ID_MAIL']]);
//         devisheet.addRow([]);
//         // devisheet.addRow(['Derivatives']);
//         // devisheet.addRow([`Futures P&L : ${(this.futopened).toFixed(2)}`]);
//         // devisheet.addRow([`Futures Turnover : ${(this.futurnover).toFixed(2)}`]);
//         // devisheet.addRow([`Options P&L : ${(this.optionopn).toFixed(2)}`]);
//         // devisheet.addRow([`Options Turnover : ${(this.opturnover).toFixed(2)}`]);
//         // devisheet.addRow([`Total Charges : ${(this.derchargers).toFixed(2)}`]);


//         // devisheet.addRow([]);

//         // if (this.chararr && this.chararr.der_charges && Array.isArray(this.chararr.der_charges)) {
//         //   devisheet.addRow(['Derivative Charges']);
//         //   devisheet.addRow(["Symbol", "Net Amount"]);
//         //   this.chararr.der_charges.forEach(element => {
//         //     devisheet.addRow([element.SCRIP_SYMBOL, element.NETAMT]);
//         //   });
//         //   devisheet.addRow([]);

//         // }

//         // Add 'Assets' data to the Equity sheet
//         combinedTables.forEach(table => {
//           if (table.heading === 'Derivative Option Open' || table.heading === 'Derivative Option Closed') {
//             devisheet.addRow([table.heading]);
//             table.data.forEach((row) => {
//               devisheet.addRow(row);
//             });
//             devisheet.addRow([]);
//           }
//         });

//         devisheet.getRow(1).height = 32.53; // Set row height to fit the image
//         devisheet.getColumn(1).width = 35; // Adjust column width to fit the image

//         devisheet.addImage(imageId, {
//           tl: { col: 0, row: 0 },
//           ext: { width: 102.53, height: 40.53 }
//         });

//         // Apply styles to the Equity sheet
//         devisheet.eachRow((row) => {
//           row.eachCell((cell) => {
//             const cellRef = cell;

//             if (cell.value === "") {
//               cellRef.border = {
//                 top: { style: 'none' },
//                 left: { style: 'none' },
//                 bottom: { style: 'none' },
//                 right: { style: 'none' }
//               };
//             }
//             if (['Equities Charges', 'Derivative Charges', 'Commodity Charges', 'Currency Charges', 'Commodity Option Open', 'Commodity Option Closed', 'Equities', 'Derivatives', 'Commodity', 'Currency', 'Derivative Option Open', 'Derivative Option Closed', 'Assets', 'Liabilities', 'Trading', 'ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED', 'Commodity Future Closed'].includes(cell.value)) {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 11,
//                 bold: true
//               };
//             } else if (['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L', 'Net Amount'].includes(cell.value)) {
//               cellRef.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F226B' } };
//               cellRef.font = { bold: true, color: { argb: 'ffffff' } };
//             }
//             cellRef.alignment = { horizontal: 'left' };
//             if (cell.value === "Tax P&L") {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 14,
//                 bold: true
//               };
//             }
//           });
//         });

//         // Adjust column width
//         devisheet.columns.forEach((column) => {
//           let maxLength = 0;
//           column.eachCell({ includeEmpty: true }, (cell) => {
//             const cellValue = cell.value ? cell.value.toString() : '';
//             maxLength = Math.max(maxLength, cellValue.length);
//           });
//           column.width = maxLength < 10 ? 10 : maxLength + 2;
//         });

//         // Add borders to all cells
//         devisheet.eachRow({ includeEmpty: false }, (row) => {
//           row.eachCell({ includeEmpty: false }, (cell) => {
//             if (cell.value !== "") {
//               cell.border = {
//                 top: { style: 'thin' },
//                 left: { style: 'thin' },
//                 bottom: { style: 'thin' },
//                 right: { style: 'thin' }
//               };
//             }
//           });
//         });

//         commsheet.addRow(["", "Tax P&L", "Client ID", this.actid]);
//         commsheet.addRow(["", "", "Client Name", this.cname]);
//         commsheet.addRow(["", "", "Client PAN", this.profiledetails['PAN_NO']]);
//         commsheet.addRow(["", "", "Client Email-Id", this.profiledetails['CLIENT_ID_MAIL']]);
//         commsheet.addRow([]);
//         // commsheet.addRow(['Commodity']);
//         // commsheet.addRow([`Futures P&L : ${(this.comnetfutamt).toFixed(2)}`]);
//         // commsheet.addRow([`Futures Turnover : ${(this.futturnover).toFixed(2)}`]);
//         // commsheet.addRow([`Options P&L : ${(this.comnetamt).toFixed(2)}`]);
//         // commsheet.addRow([`Options Turnover : ${(this.comturnover).toFixed(2)}`]);
//         // commsheet.addRow([`Total Charges : ${(this.comchargers).toFixed(2)}`]);


//         // commsheet.addRow([]);


//         // if (this.chararr && this.chararr.comm_charges && Array.isArray(this.chararr.comm_charges)) {
//         //   commsheet.addRow(['Commodity Charges']);
//         //   commsheet.addRow(["Symbol", "Net Amount"]);
//         //   this.chararr.comm_charges.forEach(element => {
//         //     commsheet.addRow([element.SCRIP_SYMBOL, element.NETAMT]);
//         //   });
//         //   commsheet.addRow([]);
//         // }

//         // Add 'Assets' data to the Equity sheet
//         combinedTables.forEach(table => {
//           if (table.heading === 'Commodity Option Open' || table.heading === 'Commodity Option Closed' || table.heading === 'Commodity Future  Closed') {
//             commsheet.addRow([table.heading]);
//             table.data.forEach((row) => {
//               commsheet.addRow(row);
//             });
//             commsheet.addRow([]);
//           }
//         });

//         commsheet.getRow(1).height = 32.53; // Set row height to fit the image
//         commsheet.getColumn(1).width = 35; // Adjust column width to fit the image

//         commsheet.addImage(imageId, {
//           tl: { col: 0, row: 0 },
//           ext: { width: 102.53, height: 40.53 }
//         });

//         // Apply styles to the Equity sheet
//         commsheet.eachRow((row) => {
//           row.eachCell((cell) => {
//             const cellRef = cell;

//             if (cell.value === "") {
//               cellRef.border = {
//                 top: { style: 'none' },
//                 left: { style: 'none' },
//                 bottom: { style: 'none' },
//                 right: { style: 'none' }
//               };
//             }
//             if (['Equities Charges', 'Derivative Charges', 'Commodity Charges', 'Currency Charges', 'Commodity Option Open', 'Commodity Option Closed', 'Equities', 'Derivatives', 'Commodity', 'Currency', 'Derivative Option Open', 'Derivative Option Closed', 'Assets', 'Liabilities', 'Trading', 'ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED', 'Commodity Future Closed'].includes(cell.value)) {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 11,
//                 bold: true
//               };
//             } else if (['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L', 'Net Amount'].includes(cell.value)) {
//               cellRef.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F226B' } };
//               cellRef.font = { bold: true, color: { argb: 'ffffff' } };
//             }
//             cellRef.alignment = { horizontal: 'left' };
//             if (cell.value === "Tax P&L") {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 14,
//                 bold: true
//               };
//             }
//           });
//         });

//         // Adjust column width
//         commsheet.columns.forEach((column) => {
//           let maxLength = 0;
//           column.eachCell({ includeEmpty: true }, (cell) => {
//             const cellValue = cell.value ? cell.value.toString() : '';
//             maxLength = Math.max(maxLength, cellValue.length);
//           });
//           column.width = maxLength < 10 ? 10 : maxLength + 2;
//         });

//         // Add borders to all cells
//         commsheet.eachRow({ includeEmpty: false }, (row) => {
//           row.eachCell({ includeEmpty: false }, (cell) => {
//             if (cell.value !== "") {
//               cell.border = {
//                 top: { style: 'thin' },
//                 left: { style: 'thin' },
//                 bottom: { style: 'thin' },
//                 right: { style: 'thin' }
//               };
//             }
//           });
//         });


//         currsheet.addRow(["", "Tax P&L", "Client ID", this.actid]);
//         currsheet.addRow(["", "", "Client Name", this.cname]);
//         currsheet.addRow(["", "", "Client PAN", this.profiledetails['PAN_NO']]);
//         currsheet.addRow(["", "", "Client Email-Id", this.profiledetails['CLIENT_ID_MAIL']]);
//         currsheet.addRow([]);
//         // currsheet.addRow(['Currency']);
//         // currsheet.addRow([`Futures P&L : ${(this.curnetfutamt).toFixed(2) ? (this.curnetfutamt).toFixed(2) : 0.0}`]);
//         // currsheet.addRow([`Futures Turnover : ${(this.curfutturnover).toFixed(2)}`]);
//         // currsheet.addRow([`Options P&L : ${(this.curopnetamt).toFixed(2)}`]);
//         // currsheet.addRow([`Options Turnover : ${(this.comopturnover).toFixed(2)}`]);
//         // currsheet.addRow([`Total Charges : ${(this.curchargers).toFixed(2)}`]);


//         // currsheet.addRow([]);





//         // if (this.chararr && this.chararr.cur_charges && this.chararr.cur_charges.length) {
//         //   currsheet.addRow(['Currency Charges']);
//         //   currsheet.addRow(["Symbol", "Net Amount"]);
//         //   this.chararr.cur_charges.forEach(element => {
//         //     currsheet.addRow([element.SCRIP_SYMBOL, element.NETAMT]);
//         //   });
//         //   currsheet.addRow([]);
//         // }



//         currsheet.getRow(1).height = 32.53; // Set row height to fit the image
//         currsheet.getColumn(1).width = 35; // Adjust column width to fit the image

//         currsheet.addImage(imageId, {
//           tl: { col: 0, row: 0 },
//           ext: { width: 102.53, height: 40.53 }
//         });

//         // Apply styles to the Equity sheet
//         currsheet.eachRow((row) => {
//           row.eachCell((cell) => {
//             const cellRef = cell;

//             if (cell.value === "") {
//               cellRef.border = {
//                 top: { style: 'none' },
//                 left: { style: 'none' },
//                 bottom: { style: 'none' },
//                 right: { style: 'none' }
//               };
//             }
//             if (['Equities Charges', 'Derivative Charges', 'Commodity Charges', 'Currency Charges', 'Commodity Option Open', 'Commodity Option Closed', 'Equities', 'Derivatives', 'Commodity', 'Currency', 'Derivative Option Open', 'Derivative Option Closed', 'Assets', 'Liabilities', 'Trading', 'ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED', 'Commodity Future Closed'].includes(cell.value)) {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 11,
//                 bold: true
//               };
//             } else if (['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L', 'Net Amount'].includes(cell.value)) {
//               cellRef.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F226B' } };
//               cellRef.font = { bold: true, color: { argb: 'ffffff' } };
//             }
//             cellRef.alignment = { horizontal: 'left' };
//             if (cell.value === "Tax P&L") {
//               cellRef.font = {
//                 name: 'Arial',
//                 size: 14,
//                 bold: true
//               };
//             }
//           });
//         });

//         // Adjust column width
//         currsheet.columns.forEach((column) => {
//           let maxLength = 0;
//           column.eachCell({ includeEmpty: true }, (cell) => {
//             const cellValue = cell.value ? cell.value.toString() : '';
//             maxLength = Math.max(maxLength, cellValue.length);
//           });
//           column.width = maxLength < 10 ? 10 : maxLength + 2;
//         });

//         // Add borders to all cells
//         currsheet.eachRow({ includeEmpty: false }, (row) => {
//           row.eachCell({ includeEmpty: false }, (cell) => {
//             if (cell.value !== "") {
//               cell.border = {
//                 top: { style: 'thin' },
//                 left: { style: 'thin' },
//                 bottom: { style: 'thin' },
//                 right: { style: 'thin' }
//               };
//             }
//           });
//         });



//         // Save the workbook
//         workbook.xlsx.writeBuffer().then((buffer) => {
//           const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//           const link = document.createElement('a');
//           link.href = URL.createObjectURL(blob);
//           link.download = `Tax_P&L_${this.fromshow}.xlsx`;
//           link.click();
//         }).catch(error => console.error('Error generating Excel file:', error));
      }
else if (data == 'Download Pdf') {
     this.downpdfrexel = data
        this.apiexcelcl()
        console.log("15224",this.toshow , this.fromdateapi);
        

                // this.showDownloadDialog = true; 
               
}

      else if (data == 'Download Pdf new') {

console.log("test pdfff");


        var doc = new jsPDF();

        let currentY = 14.5;

        doc.setFontSize(14);
        doc.setFont('bold');
        doc.text('Tax Pnl', 90, currentY);
        currentY += 8;

        doc.setLineWidth(0.2);
        doc.setDrawColor(0);
        doc.line(0, currentY, 218, currentY);
        currentY += 4;

        doc.addImage(zebupdfImage, 'PNG', 9, 8, 20, 10);

        const clientInfo = [
          `Client Name   :  ${this.cname}`,
          `Client Code    :  ${this.actid}`,
          `PAN               :  ${this.profiledetails['PAN_NO']}`,
          `Email Id         :  ${this.profiledetails['CLIENT_ID_MAIL']}`
        ];

        clientInfo.forEach(line => {
          doc.setFontSize(7);
          doc.setFont('bold');
          doc.text(line, 15, currentY);
          currentY += 4;
        });

        const rightInfo = [
          `From     :  ${this.fromdateapi}`,
          `To         :  ${this.toshow}`,
          `Mobile  :  ${this.profiledetails['MOBILE_NO']}`,
          `Address :  ${this.profiledetails['CL_RESI_ADD1']}`,
          `${this.profiledetails['CL_RESI_ADD2']}`,
          `${this.profiledetails['CL_RESI_ADD3']}`
        ];
        currentY = currentY - 16
        rightInfo.forEach(line => {
          doc.setFontSize(7);
          doc.setFont('bold');
          doc.text(line, 130, currentY);
          currentY += 4;
        });

        // currentY += 5;

        // Section headings
        // doc.setFontSize(11);
        // doc.setFont('bold');
        // doc.text('Equities', 15, currentY);
        // doc.text('Derivatives', 72, currentY);
        // doc.text('Commodity', 115, currentY);
        // doc.text('Currency', 158, currentY);

        // currentY += 8;

        // Prepare all section data
        // const equityFields = [
        //   ['Long Term Realized P&L :', (this.longnetval).toFixed(2)],
        //   ['Short Term Realized P&L :', (this.stnetamt).toFixed(2)],
        //   ['Trading P&L :', (this.tradenetamt).toFixed(2)],
        //   ['Assets P&L :', (this.assnetamt).toFixed(2)],
        //   ['Trading Turnover :', (this.totalintraday).toFixed(2)],
        //   ['Total Charges :', (this.segval).toFixed(2)]
        // ];

        // const derFields = [
        //   ['Futures P&L :', (this.futopened).toFixed(2)],
        //   ['Futures Turnover :', (this.futurnover).toFixed(2)],
        //   ['Options P&L :', (this.optionopn).toFixed(2)],
        //   ['Options Turnover :', (this.opturnover).toFixed(2)],
        //   ['Total Charges :', (this.derchargers).toFixed(2)]
        // ];

        // const comFields = [
        //   ['Futures P&L :', (this.comnetfutamt).toFixed(2)],
        //   ['Futures Turnover :', (this.futturnover).toFixed(2)],
        //   ['Options P&L :', (this.comnetamt).toFixed(2)],
        //   ['Options Turnover :', (this.comturnover).toFixed(2)],
        //   ['Total Charges :', (this.comchargers).toFixed(2)]
        // ];

        // const curFields = [
        //   ['Futures P&L :', this.cornetfutamt ? (this.cornetfutamt).toFixed(2) : '0.00'],
        //   ['Futures Turnover :', this.curfutturnover ? (this.curfutturnover).toFixed(2) : '0.00'],
        //   ['Options P&L :', this.curopnetamt ? (this.curopnetamt).toFixed(2) : '0.00'],
        //   ['Options Turnover :', this.comopturnover ? (this.comopturnover).toFixed(2) : '0.00'],
        //   ['Total Charges :', this.curchargers ? (this.curchargers).toFixed(2) : '0.00']
        // ];

        // Determine max rows to print
        // const maxRows = Math.max(
        //   equityFields.length,
        //   derFields.length,
        //   comFields.length,
        //   curFields.length
        // );

        // for (let i = 0; i < maxRows; i++) {
        //   if (equityFields[i]) {
        //     doc.setFontSize(8);
        //     doc.setFont('bold');
        //     doc.setTextColor(0, 0, 0);
        //     doc.text(equityFields[i][0], 15, currentY);
        //     doc.setTextColor(117, 115, 115);
        //     doc.text(equityFields[i][1], 50, currentY);
        //   }

        //   if (derFields[i]) {
        //     doc.setFontSize(8);
        //     doc.setFont('bold');
        //     doc.setTextColor(0, 0, 0);
        //     doc.text(derFields[i][0], 72, currentY);
        //     doc.setTextColor(117, 115, 115);
        //     doc.text(derFields[i][1], 96, currentY);
        //   }

        //   if (comFields[i]) {
        //     doc.setFontSize(8);
        //     doc.setFont('bold');
        //     doc.setTextColor(0, 0, 0);
        //     doc.text(comFields[i][0], 115, currentY);
        //     doc.setTextColor(117, 115, 115);
        //     doc.text(comFields[i][1], 140, currentY);
        //   }

        //   if (curFields[i]) {
        //     doc.setFontSize(8);
        //     doc.setFont('bold');
        //     doc.setTextColor(0, 0, 0);
        //     doc.text(curFields[i][0], 158, currentY);
        //     doc.setTextColor(117, 115, 115);
        //     doc.text(curFields[i][1], 182, currentY);
        //   }

        //   currentY += 5;
        // }

        currentY += 5;

        // Now your tables go below as before

        const columnStyles = {
          0: { fontStyle: 'bold', textColor: [0, 0, 0], halign: 'left' },
          1: { halign: 'left' },
          2: { halign: 'left' },
          3: { halign: 'left' },
          4: { halign: 'left' },
          5: { halign: 'left' },
          6: { halign: 'left' },
          7: { halign: 'left' },
          8: { halign: 'left' },
          9: { halign: 'left' },
        };

        if (eqarray.length > 0) {
          doc.setFontSize(12);
          doc.setFont('bold');
          doc.setTextColor(0, 0, 0);
          doc.text('Bifurcation of Bill', 15, currentY);
          currentY += 8;

          let rows = eqarray.map(e => [e.name, e.value, e.value2, e.value3, e.value4]);

          autoTable(doc, {
            head: [['Particulars', 'Equity', 'Derivative', 'Commodity', 'Currency']],
            body: rows,
            startY: currentY,
            styles: { fontSize: 7, lineColor: [200, 200, 200] },
            theme: 'grid',
            headStyles: {
              fillColor: [31, 52, 101],
              textColor: [255, 255, 255]
            },
            columnStyles: columnStyles
          });

          currentY = doc.lastAutoTable.finalY + 10;
        }







        const tables = this.downloadarrayForPdf && this.downloadarrayForPdf.length
          ? this.downloadarrayForPdf.slice().sort((a, b) => a.id - b.id)
          : [];

        tables.forEach((table) => {
          doc.setFontSize(12);
          doc.setFont('bold');
          doc.text(table.heading, 15, currentY);
          currentY += 8;

          let tableData = JSON.parse(JSON.stringify(table.data)).splice(1);

          autoTable(doc, {
            head: [table.data[0]],
            body: tableData,
            startY: currentY,
            styles: { fontSize: 7, lineColor: [200, 200, 200] },
            theme: 'grid',
            columnStyles: columnStyles,

            headStyles: {
              fillColor: [31, 52, 101],
              textColor: [255, 255, 255]
            }
          });

          currentY = doc.lastAutoTable.finalY + 10;
        });

        var totalPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          const footerY = doc.internal.pageSize.height - 9;

          doc.setLineWidth(0.2);
          doc.setDrawColor(0);
          doc.line(0, footerY - 4, 218, footerY - 4);

          doc.setFontSize(6);
          doc.text(14, footerY, 'Zebu Share And Wealth Management Private Limited');
          doc.setFontSize(4);
          doc.text(14, footerY + 2, 'Correspondence Office:No: 301, 4th Main Road, Burma Colony, Perungudi, Chennai, Tamil Nadu 600 096.');
          doc.text(84, footerY + 2, 'Phone No:044-4855 7991, Fax :044-4855 7991');
          doc.text(14, footerY + 4, 'TRADING MEMBER CODE: NSE-EQ,F&O,CDS,COM: 13179 , BSE-EQ,F&O,CD,COM: 6550, MSEI - EQ,F&O,CDS:83300 CIN NO: U67120TZ2013PTC019704');
          doc.text(109, footerY + 4, 'Website Address :- www.zebuetrade.com ,Investor Grievances Email id: grievance@zebuetrade.com');
        }

        doc.save('Tax pnl.pdf');
      }



      //pdf


    },
    gettradedata() {
      this.menu2 = false
      this.eqloader = true
      this.dessertsexpand = []
      this.dessertsexpandderivative = []
      this.dessertsexpandcommodity = []
      this.dessertsexpandcurrency = []

      this.disabletabs = true
      this.disabletabsexpense = true
      this.dessertsoriginal = []

      if (this.fromdate != '' && this.todate != '') {
        this.loader = true
        var fromdate = ''
        var todate = ''
        let dateString = this.fromdate
        let dateObject = new Date(dateString);
        let year = dateObject.getFullYear();
        let month = dateObject.getMonth() + 1; // Months are 0-indexed, so add 1
        let day = dateObject.getDate();
        let formattedDate = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + year;
        fromdate = formattedDate
        this.fromshow = fromdate
        this.fromdateapi = fromdate
        let dateString1 = this.todate
        let dateObject1 = new Date(dateString1);
        let year1 = dateObject1.getFullYear();
        let month1 = dateObject1.getMonth() + 1; // Months are 0-indexed, so add 1
        let day1 = dateObject1.getDate();
        let formattedDate1 = (day1 < 10 ? '0' : '') + day1 + '/' + (month1 < 10 ? '0' : '') + month1 + '/' + year1;
        todate = formattedDate1
        this.toshow = todate
        this.fromshow = this.fromshow + '/' + this.toshow
        this.equitiesdata()
        this.derivativesdat()
        // const axios = require("axios");
        // let data = JSON.stringify({
        //   "cc": this.actid,
        //   "from": fromdate,
        //   "to": todate
        // });

        // let config = {
        //   method: "post",
        //   maxBodyLength: Infinity,
        //   url: `${apiurl}/getpnl`,

        //   headers: {
        //     'Content-Type': 'application/json',
        //     'clientid': this.actid,
        //     'Authorization': this.susertoken
        //   },
        //   data: data,
        // };
        // let axiosthis = this;
        // axios.request(config)
        //   .then((response) => {
        //     let res = response.data
        //     if (res != 'no data found') {
        //       axiosthis.desserts = response.data["transactions"];
        //       // console.log(axiosthis.desserts,'kjkjkj');
        //       axiosthis.dessertspop = response.data["transactions"];
        //       axiosthis.dessertsexpense = response.data["expenses"];
        //       axiosthis.dessertspopexpense = response.data["expenses"];
        //       var headval = response.data

        //       axiosthis.disrealised_pnl = axiosthis.headerval.realised_pnl
        //       axiosthis.disunrealised_pnl = axiosthis.headerval.unrealised_pnl
        //       axiosthis.headervalpop = response.data;
        //       // console.log(axiosthis.desserts, 'lklklklk');

        //       axiosthis.itemperpage = axiosthis.desserts.length
        //       let data1 = JSON.stringify({
        //         "cc": this.actid,

        //       });

        //       let config1 = {
        //         method: 'post',
        //         maxBodyLength: Infinity,
        //         url: `${apiurl}/getpnlsummary`,
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'clientid': this.actid,
        //           'Authorization': this.susertoken
        //         },
        //         data: data1
        //       };
        //       // var axiosthis = this
        //       axios.request(config1)
        //         .then((response) => {
        //           axiosthis.headerval = headval
        //           axiosthis.disunrealised_pnl = axiosthis.headerval.unrealised_pnl
        //           axiosthis.disrealised_pnl = axiosthis.headerval.realised_pnl
        //           //// // //console.log(JSON.stringify(response.data));
        //           // // // //console.log(response.data, typeof response.data,'');
        //           axiosthis.desserts2 = response.data
        //           for (const [key, value] of Object.entries(axiosthis.desserts2)) {
        //             // // // //console.log(key, value, "axiosthis..");
        //             for (let i = 0; i < value.length; i++) {
        //               axiosthis.desserts23.push(value[i])
        //               this.keyyy = key
        //             }
        //           }
        //           // console.log(axiosthis.desserts, 'lklklklk');

        //           for (let i = 0; i < axiosthis.desserts23.length; i++) {
        //             let smdata = axiosthis.desserts23[i].SCRIP_SYMBOL;
        //             for (let y = 0; y < axiosthis.desserts.length; y++) {
        //               let famItem = axiosthis.desserts[y]['SCRIP_SYMBOL'];
        //               if (famItem && smdata === famItem) {
        //                 // console.log('found');
        //                 if (!axiosthis.desserts[y].detailed) {
        //                   axiosthis.desserts[y].detailed = [];
        //                 }
        //                 axiosthis.desserts[y].detailed.push(axiosthis.desserts23[i]);
        //               }
        //             }
        //           }
        //           axiosthis.dessertsoriginal = axiosthis.desserts
        //           if (axiosthis.dessertsoriginal != []) {
        //             axiosthis.loader = false;
        //           }

        //           // console.log(axiosthis.desserts, 'lklklklk');
        //           axiosthis.itemperpage1 = axiosthis.desserts23.length
        //           axiosthis.detpop = axiosthis.desserts23

        //         })
        //         .catch((error) => {
        //           if (error.message == 'Network Error') {
        //             this.msg = error.message
        //             axiosthis.loader = false
        //             axiosthis.alert = true
        //             setTimeout(() => {
        //               axiosthis.alert = false
        //             }, 5000);
        //           }
        //         });
        //     } else {
        //       // 
        //     }



        //     // //// // //console.log("axiosthis.desserts", axiosthis.desserts);
        //   })
        //   .catch((error) => {
        //     // // //console.log(error);
        //     if (error.message == 'Network Error') {
        //       this.msg = error.message
        //       axiosthis.loader = false
        //       axiosthis.alert = true
        //       setTimeout(() => {
        //         axiosthis.alert = false
        //       }, 5000);
        //       // alert(error.message)
        //     }
        //   });
        // // const axios = require('axios');

        // // this.equitiesdata()
        // // this.derivativesdat()

      }
    },


    // dateinsert() {
    //   //console.log('kjj')
    //   var fromdate = ''
    //   // var todate = ''
    //   let dateString = this.fromdate
    //   let dateObject = new Date(dateString);
    //   let year = dateObject.getFullYear();
    //   let month = dateObject.getMonth() + 1; // Months are 0-indexed, so add 1
    //   let day = dateObject.getDate();
    //   let formattedDate = (day < 10 ? '0' : '') + day + '-' + (month < 10 ? '0' : '') + month + '-' + year;
    //   fromdate = formattedDate
    //   this.fromshow = fromdate
    //   this.fromdateapi = fromdate

    // },
    tabdata(item) {
      this.tabvaluestack = item;
    },
    toggleExpanded(item) {
      // console.log("fgfg", item)
      const index = this.expanded.indexOf(item);
      if (index === -1) {
        this.expanded = this.singleExpand ? [item] : [...this.expanded, item];
      } else {
        this.expanded = this.expanded.filter((el) => el !== item);
      }
    },
    toggleExpanded1(item) {
      const index = this.expandedder.indexOf(item);
      if (index === -1) {
        this.expandedder = this.singleExpand ? [item] : [...this.expandedder, item];
      } else {
        this.expandedder = this.expandedder.filter((el) => el !== item);
      }
    },
    toggleExpanded2(item) {
      const index = this.expandedcom.indexOf(item);
      if (index === -1) {
        this.expandedcom = this.singleExpand ? [item] : [...this.expandedcom, item];
      } else {
        this.expandedcom = this.expandedcom.filter((el) => el !== item);
      }
    },
    toggleExpanded3(item) {
      const index = this.expandedcur.indexOf(item);
      if (index === -1) {
        this.expandedcur = this.singleExpand ? [item] : [...this.expandedcur, item];
      } else {
        this.expandedcur = this.expandedcur.filter((el) => el !== item);
      }
    },
    toggleExpanded4(item) {
      const index = this.expandedinner.indexOf(item);
      if (index === -1) {
        this.expandedinner = this.singleExpand ? [item] : [...this.expandedinner, item];
      } else {
        this.expandedinner = this.expandedinner.filter((el) => el !== item);
      }
    },
    detailedpop(item) {
      // console.log(item);
      // alert("dfd")
      this.search = ''
      let detailedarr = item
      this.detailedpoparray = detailedarr.detailed

      this.finaltotal = 0
      for (let i = 0; i < this.detailedpoparray.length; i++) {
        this.finaltotal += this.detailedpoparray[i].NET_AMOUNT

      }
      // console.log(this.detailedpoparray[0]);
      this.dialog = true
      // console.log(item);
      // this.scriptname = item.SCRIP_SYMBOL

      // this.itemperpage1inner = this.detailedpoparray.length

    },
    detailedpopmobile(item) {
      this.search = ''
      let detailedarr = item
      this.detailedpoparray = detailedarr.detailed

      this.finaltotal = 0
      for (let i = 0; i < this.detailedpoparray.length; i++) {
        this.finaltotal += this.detailedpoparray[i].NETAMT

      }
      // console.log(this.detailedpoparray[0]);
      this.dialogmobile = true
      // console.log(item);
      this.scriptname = item.SCRIP_SYMBOL

      this.itemperpage1inner = this.detailedpoparray.length
    },
    filterseg1(filterdata_unpl1) {
      var data = this.detpop
      // const dataval = this.desserts
      // const data2 = this.desserts
      // const data3 = this.desserts
      const seg = filterdata_unpl1
      // // // //console.log("sssss", seg);
      if (seg == 'Equities') {
        this.desserts23 = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPANY_CODE == 'NSE_CASH' || data[i].COMPANY_CODE == 'BSE_CASH') {
            this.desserts23.push(data[i])
          }
        }


        //console.log(this.disunrealised_pnl, 'this.headerval.total_invested');
      } else if (seg == 'Future & Options') {
        this.desserts23 = []
        // const data1 = this.desserts
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPANY_CODE == 'NSE_FNO' || data[i].COMPANY_CODE == 'BSE_FNO') {
            this.desserts23.push(data[i])
          }
        }
      } else if (seg == 'Commodities') {
        this.desserts23 = []
        // const data1 = this.desserts
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPANY_CODE == 'MCX') {
            this.desserts23.push(data[i])
          }
        }
      } else if (seg == 'Currencies') {
        this.desserts23 = []
        // const data1 = this.desserts
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPANY_CODE == 'CD_NSE') {
            this.desserts23.push(data[i])
          }
        }
      } else if (seg == 'All') {
        this.desserts23 = data
      }
    },
    filterseg(filterdata_unpl) {
      var data = this.dessertspop
      // var data1 = this.dessertspopexpense
      var headrea = this.headervalpop.realised_pnl
      var headrea1 = this.headervalpop.unrealised_pnl
      // expense_amt
      // unrealised_pnl
      // realised_pnl
      // //console.log(data1,headrea);
      // const dataval = this.desserts
      // const data2 = this.desserts
      // const data3 = this.desserts
      const seg = filterdata_unpl
      // alert("summary");
      if (seg == 'Equities') {
        let addval = 0
        let unaddval = 0

        this.dessertsoriginal = []
        this.dessertstaxdis = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPCODE == 'BSE_CASH' || data[i].COMPCODE == 'NSE_CASH' || data[i].COMPCODE == 'MF_BSE' || data[i].COMPCODE == 'MF_NSE' || data[i].COMPCODE == 'NSE_SLBM' || data[i].COMPCODE == 'NSE_SPT') {
            this.dessertsoriginal.push(data[i])

          }

        }

        // for (let e = 0; e < data1.length; e++) {
        //     if (data1[e].COMPCODE == 'BSE_CASH' || data1[e].COMPCODE == 'NSE_CASH' || data1[e].COMPCODE == 'MF_BSE' || data1[e].COMPCODE == 'MF_NSE' || data1[e].COMPCODE == 'NSE_SLBM' || data1[e].COMPCODE == 'NSE_SPT') {
        //         this.desserts.push(data1[e])
        //     }
        // }

        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY == 0) {

            addval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disrealised_pnl = addval
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY != 0) {

            unaddval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disunrealised_pnl = unaddval



        // //console.log(this.headerval.realised_pnl, "sisisisi");






        // }
        // for (let i = 0; i < this.desserts23.length; i++) {
        //     if (this.desserts23[i].NET_QUANTITY != 0) {
        //         this.disunrealised_pnl = this.desserts23[i].reduce((accumulator, object) => {
        //             return accumulator + object.BUY_RATE;
        //         }, 0);
        //     }
        // }
        //console.log(this.disunrealised_pnl, this.disrealised_pnl);
        // // // //console.log(this.dessertsoriginal, "this.dessertsoriginal");
      } else if (seg == 'Future & Options') {
        this.dessertsoriginal = []
        let addval = 0
        let unaddval = 0

        // const data1 = this.dessertsoriginal
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPCODE == 'NSE_FNO' || data[i].COMPCODE == 'BSE_FNO   ') {
            this.dessertsoriginal.push(data[i])

          }
        }
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY == 0) {

            addval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disrealised_pnl = addval
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY != 0) {

            unaddval += this.dessertsoriginal[y].NOT_PROFIT
          }
          // else{
          //     // alert("kl")
          // }

        }
        this.disunrealised_pnl = unaddval
        // // // //console.log(this.dessertsoriginal, "this.dessertsoriginal");
      } else if (seg == 'Commodities') {
        this.dessertsoriginal = []
        let addval = 0
        let unaddval = 0

        // const data1 = this.dessertsoriginal
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPCODE == 'MCX' || data[i].COMPCODE == 'NCDEX' || data[i].COMPCODE == 'NSE_COM' || data[i].COMPCODE == 'BSE_COM') {
            this.dessertsoriginal.push(data[i])
          }
        }
        //console.log(this.dessertsoriginal);
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY == 0) {

            addval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disrealised_pnl = addval
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY != 0) {

            unaddval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disunrealised_pnl = unaddval
        // // // //console.log(this.dessertsoriginal, "this.dessertsoriginal");
      } else if (seg == 'Currencies') {
        this.dessertsoriginal = []
        let addval = 0
        let unaddval = 0

        // const data1 = this.dessertsoriginal
        for (let i = 0; i < data.length; i++) {
          if (data[i].COMPCODE == 'CD_NSE' || data[i].COMPCODE == 'CD_MCX' || data[i].COMPCODE == 'CD_USE' || data[i].COMPCODE == 'CD_BSE') {
            this.dessertsoriginal.push(data[i])
          }
        }

        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY == 0) {

            addval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disrealised_pnl = addval
        for (let y = 0; y < this.dessertsoriginal.length; y++) {
          if (this.dessertsoriginal[y].NET_QUANTITY != 0) {

            unaddval += this.dessertsoriginal[y].NOT_PROFIT
          }

        }
        this.disunrealised_pnl = unaddval
        // // // //console.log(this.dessertsoriginal, "this.dessertsoriginal");
      } else if (seg == 'All') {
        this.dessertsoriginal = data

        this.disrealised_pnl = headrea
        this.disunrealised_pnl = headrea1
      }
    },
    downloaddet(item) {

      this.sheet1 = false
      this.radios1 = null
      let data = item
      // // // //console.log("dsdsdsdsds", data);

      if (data == 'Download Excel') {
        // // const data = this.desserts23;
        // // let jsonObj = JSON.parse(data);
        // // data.forEach(function (v) { delete v.ACCOUNTCODE }, { delete v.ACCOUNTNAME });
        // let dada = this.desserts23;
        // // let jsonObj = JSON.parse(data);
        // // data.forEach(function (v) { delete v.ACCOUNTCODE }, { delete v.ACCOUNTNAME });
        // //                 dada.forEach(function (v) {
        // //                     // delete v.SCRIP_SYMBOL

        // //                     delete v.MARKET
        // // ;
        // //                     // delete v.NSE_SCRIPCODE;
        // //                     delete v.EXCHANGE
        // // ;
        // //                     delete v.COMPANY_CODE
        // //                     delete v.CLOSING_PRICE
        // //                 });
        // const exportType = exportFromJSON.types.csv;
        // const filename = `${'Detailed_'}${'Profit and Loss_'}${this.year}`
        // if (dada) exportFromJSON({ data: dada, filename: filename, exportType: exportType });
      } 
      else if (data == 'Download Pdf') {
        let rows = [];
        let columnHeader = ['Trade date', 'Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'P&L'];
        let pdfName = `${'Detailed_Profit and loss_'}${this.yearis}`
        // doc.text(`Ledger_${this.yearis}`, 10, 10);
        // doc.text('Zebu', 10 ,10)
        this.desserts23.forEach(element => {
          var temp = [
            element.TRADE_DATE, element.SCRIP_NAME, element.BQTY, element.BRATE, element.SQTY, element.SRATE, element.NETQTY, element.NRATE, element.PRO
          ];
          rows.push(temp);
        });
        var doc = new jsPDF();
        autoTable(doc, { head: [columnHeader], body: rows, });
        doc.save(pdfName + '.pdf');
      }

    },
    downloadsum(item) {

      this.sheet = false
      this.radios = null

      let data = item
      // // //console.log("dsdsdsdsds", data);

      if (data == 'Download Excel') {
        
        let dada = this.dessertsoriginal;
        // let jsonObj = JSON.parse(data);
        // data.forEach(function (v) { delete v.ACCOUNTCODE }, { delete v.ACCOUNTNAME });
        // vgb
        const exportType = exportFromJSON.types.csv;
        const filename = `${'Summary_'}${'Profit and Loss_'}${this.year}`
        // // //console.log("dada",this.year,dada)
        if (dada) {
          // // //console.log("inside",dada);
          exportFromJSON({ data: dada, fileName: filename, exportType: exportType });
        }
      } else if (data == 'Download Pdf') {
        let rows = [];
        let columnHeader = ['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'P & L'];
        let pdfName = `${'Summary_Profit and loss_'}${this.yearis}`
        // doc.text(`Ledger_${this.yearis}`, 10, 10);
        // doc.text('Zebu', 10 ,10)
        this.dessertsoriginal.forEach(element => {
          var temp = [
            element.SCRIP_SYMBOL, element.BUY_QUANTITY, element.BUY_RATE, element.SALE_QUANTITY, element.SALE_RATE, element.NET_QUANTITY, element.NET_RATE, element.NOT_PROFIT
          ];
          rows.push(temp);
        });
        var doc = new jsPDF();
        autoTable(doc, { head: [columnHeader], body: rows, });
        doc.save(pdfName + '.pdf');
      }
    },
    detailed() {
      this.summary = false
    },
    summary1() {
      this.summary = true
    },
    lessbtn() {
      this.more = true
      this.less = false
      this.itemperpage = 8
    },
    morebtn() {
      this.more = false
      this.less = true
      this.itemperpage = this.dessertsoriginal.length
    },
    lessbtn1() {
      this.more1 = true
      this.less1 = false
      this.itemperpage1 = 8
    },
    morebtn1() {
      this.more1 = false
      this.less1 = true
      this.itemperpage1 = this.desserts23.length
    },
    equitiesdata() {
      this.eqloader = true
      this.loader = true
      this.tables = []
      const axios = require('axios');
      let data = JSON.stringify({
        "cc": this.actid,
        'from': this.fromdateapi,
        'to': this.toshow
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'http://192.168.5.138:9003/getequitypnl',
        url: `${apiurl}/getequitypnl`,

        headers: {
          'Content-Type': 'application/json',
          'clientid': this.actid,
          'Authorization': this.susertoken
        },
        data: data
      };
      let axiosthis = this
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosthis.eqloader = false
          var headerForPdf = ['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L']

          axiosthis.loader = false
          if (response.data.msg == 'No Data Available') {
            axiosthis.eqloader = false
            axiosthis.loader = false
            axiosthis.dessertsexpand = []
            axiosthis.newstateq = []
          } else {
            const addass = response.data.ASSETS
            const addlab = response.data.LIABILITIES
            const addst = response.data.SHORTTERM
            const addtrd = response.data.TRADING
            const addtrdlong = response.data.LONGTERM
            const categories = ['ASSETS', 'LIABILITIES', 'SHORTTERM', 'TRADING', 'LONGTERM'];
            axiosthis.newstateq = response.data.details
            // axiosthis.downloadarray = [];

            categories.forEach(category => {
              const data = response.data[category] || [];
              axiosthis.downloadarray.push(...data);
            });
            // console.log(axiosthis.downloadarray, "DADA");
            if (addass) {
              // Add 'Assets' heading and data array to tables
              axiosthis.tables.push({ heading: 'Assets', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = addass.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Assets');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }

              // console.log(axiosthis.tables);
              axiosthis.dessertsexpand.push({ name: 'Assets', val: addass })
              // axiosthis.tables.push({ name: 'Assets', val: addass })
              const assnetAmtSum = addass.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              axiosthis.assnetamt = assnetAmtSum
              // console.log("Sum of NETAMT values:", assnetAmtSum);
              const asssell = response.data.ASSETS
              var asssellval = asssell.reduce((sum, item) => sum + Number(item.SALE_AMT), 0);
              var assbuyval = asssell.reduce((sum, item) => sum + Number(item.BUY_AMT), 0);
            } else {
              asssellval = 0
              assbuyval = 0
            }
            if (addlab) {
              // Add 'Assets' heading and data array to tables
              axiosthis.tables.push({ heading: 'Liabilities', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = addlab.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Liabilities');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }

              axiosthis.dessertsexpand.push({ name: 'Liabilities', val: addlab })
              const labsell = response.data.LIABILITIES
              var labsellval = labsell.reduce((sum, item) => sum + Number(item.SALE_AMT), 0);
              var sellbuyval = labsell.reduce((sum, item) => sum + Number(item.BUY_AMT), 0);
            } else {
              labsellval = 0
              sellbuyval = 0
            }
            if (addst) {
              axiosthis.tables.push({ heading: 'Short Term', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = addst.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Short Term');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpand.push({ name: 'Short Term', val: addst })

              const stnetAmtSum = addst.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              // console.log("Sum of stnetAmtSum values:", stnetAmtSum);
              axiosthis.stnetamt = stnetAmtSum
              const stsell = response.data.SHORTTERM
              var stsellval = stsell.reduce((sum, item) => sum + Number(item.SALE_AMT), 0);
              var stbuyval = stsell.reduce((sum, item) => sum + Number(item.BUY_AMT), 0);
            } else {
              stsellval = 0
              stbuyval = 0
            }
            if (addtrd) {
              axiosthis.tables.push({ heading: 'Trading', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = addtrd.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Trading');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpand.push({ name: 'Trading', val: addtrd })
              const tradenetAmtSum = addtrd.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              // console.log("Sum of tradenetAmtSum values:", tradenetAmtSum);
              axiosthis.tradenetamt = tradenetAmtSum
              const tradesell = response.data.TRADING
              var tradesellval = tradesell.reduce((sum, item) => sum + Number(item.SALE_AMT), 0);
              var tradebuyval = tradesell.reduce((sum, item) => sum + Number(item.BUY_AMT), 0);
            } else {
              tradesellval = 0
              tradebuyval = 0
            }

            if (addtrdlong) {
              axiosthis.tables.push({ heading: 'Long Term', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = addtrdlong.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Long Term');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpand.push({ name: 'Long Term', val: addtrdlong })
              const assnetAmtSum = addtrdlong.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              axiosthis.longnetval = assnetAmtSum
              // console.log("Sum of NETAMT values:", assnetAmtSum);
              // const asssell = response.data.ASSETS
              // var asssellval = asssell.reduce((sum, item) => sum + Number(item.SALE_AMT), 0);
              // var assbuyval = asssell.reduce((sum, item) => sum + Number(item.BUY_AMT), 0);
            } else {
              // asssellval = 0
              // assbuyval = 0
            }
            // console.log(addass, "DADA");
            const totalval = asssellval + assbuyval + labsellval + sellbuyval + stsellval + stbuyval + tradesellval + tradebuyval
            this.totalintraday = totalval
          }


          // console.log(totalval, asssellval, assbuyval, sellbuyval, sellbuyval, "totalval");

          // console.log(response.data.Equity.assets);
          // axiosthis.assnetamt = addass.reduce((accumulator, object) => {
          //   return accumulator + object.Notional_PandL;
          // }, 0);
          // console.log("Sum of asset add values:", axiosthis.assnetamt);














          // const add = response.data.Equity.trading
          // const tradenetAmtSum = add.reduce((sum, item) => sum + item.NETAMT, 0);
          // console.log("Sum of tradenetAmtSum values:", tradenetAmtSum);
          // length code
          // axiosthis.dessertsexpand = []
          // const eqassetsdata = response.data.Equity.assets
          // if (eqassetsdata.length > 0) {
          //   axiosthis.dessertsexpand.push({ "name": 'Assets', "val": eqassetsdata })
          // }
          // const eqstermdata = response.data.Equity.short_term
          // if (eqstermdata.length > 0) {
          //   axiosthis.dessertsexpand.push({ "name": 'Short Term', "val": eqstermdata })
          // }
          // const eqtradingdata = response.data.Equity.trading
          // if (eqtradingdata.length > 0) {
          //   axiosthis.dessertsexpand.push({ "name": 'Trading', "val": eqtradingdata })
          // }
          // console.log(axiosthis.dessertsexpand);
          // //  dervatives
          // axiosthis.dessertsexpandderivative = []
          // const deri_fu_op_data = response.data.Derivatives.der_Fut_booked
          // if (deri_fu_op_data.length > 0) {
          //   axiosthis.dessertsexpandderivative.push({ "name": 'Future Closed', "val": deri_fu_op_data })
          // }
          // const deri_fu_cl_data = response.data.Derivatives.der_Fut_open
          // if (deri_fu_cl_data.length > 0) {
          //   axiosthis.dessertsexpandderivative.push({ "name": 'Future Open', "val": deri_fu_cl_data })
          // }
          // const der_op_opn_data = response.data.Derivatives.der_Opt_booked
          // if (der_op_opn_data.length > 0) {
          //   axiosthis.dessertsexpandderivative.push({ "name": 'Option Closed', "val": der_op_opn_data })
          // }
          // const der_op_cl_data = response.data.Derivatives.der_Opt_open
          // if (der_op_cl_data.length > 0) {
          //   axiosthis.dessertsexpandderivative.push({ "name": 'Option Open', "val": der_op_cl_data })
          // }
          // console.log(axiosthis.dessertsexpandderivative);
          // simplify code
          // function pushToDessertsExpand(array, response, category, name) {
          //   const data = response.data[category];
          //   // const data = response.data[category];
          //   if (data.length > 0) {
          //     array.push({ name, val: data });
          //   }
          // }
          // let valdata = response.data['ASSETS'];
          // let valarray = [];
          // let valarray1 = [];
          // for (let t = 0; t < valdata.length; t++) {
          //   if (valdata[t].Close === 0) {
          //     valarray.push(valdata[t]);
          //   } else {
          //     valarray1.push(valdata[t]);
          //   }
          // }
          // axiosthis.dessertsexpandinner
          // console.log(valarray1, valarray, "valarray1valarray1");
          // axiosthis.dessertsexpand = [];
          // axiosthis.dessertsexpandinner.push({ name: 'WithCloseValue', val: valarray }, { name: 'Withoutclosevalue', val: valarray1 })
          // console.log(axiosthis.dessertsexpandinner, "dessertsexpandinnerdessertsexpandinnerdessertsexpandinnerdessertsexpandinner");
          // let headassert = [
          //   {
          //     text: 'Symbol',
          //     align: 'start',
          //     sortable: false,
          //     value: 'SCRIP_NAME',
          //   },
          //   { text: 'Open Qty', value: 'NETQTY' },
          //   { text: 'Open Rate', value: 'NRATE' },
          //   { text: 'Buy Qty', value: 'BQTY' },
          //   { text: 'Buy Rate', value: 'BRATE' },
          //   { text: 'Sell Qty', value: 'SQTY' },
          //   { text: 'Sell Rate', value: 'SRATE' },
          //   { text: 'Close price', value: 'Close' },
          //   { text: 'Current Value', value: 'Curr_Value' },
          //   { text: 'Notional P&l', value: 'Notional_PandL' },
          //   // { text: '', value: 'data-table-expand' },
          // ]
          // let headshort = [
          //   {
          //     text: 'Symbol',
          //     align: 'start',
          //     sortable: false,
          //     value: 'SCRIP_NAME',
          //   },
          //   { text: 'Net Amount', value: 'NETAMT' },
          //   { text: 'Buy Qty', value: 'BQTY' },
          //   { text: 'Buy Rate', value: 'BRATE' },
          //   { text: 'Buy Amount', value: 'BAMT' },

          //   { text: 'Sell Qty', value: 'SQTY' },
          //   { text: 'Sell Rate', value: 'SRATE' },
          //   { text: 'Sell Amount', value: 'SAMT' },
          //   // { text: 'Close price', value: 'Close' },
          //   // { text: 'Current Value', value: 'Curr_Value' },
          //   { text: 'Notional P&l', value: 'NETAMT' },
          //   // { text: '', value: 'data-table-expand' },
          // ]
          // let headliab = [
          //   {
          //     text: 'Symbol',
          //     align: 'start',
          //     sortable: false,
          //     value: 'SCRIP_NAME',
          //   },
          //   { text: 'Open Qty', value: 'NETQTY' },
          //   { text: 'Open Rate', value: 'NRATE' },
          //   { text: 'Net Amount', value: 'NETAMT' },
          //   // { text: 'Buy Qty', value: 'BQTY' },
          //   // { text: 'Buy Rate', value: 'BRATE' },
          //   // { text: 'Buy Amount', value: 'BAMT' },

          //   { text: 'Sell Qty', value: 'SQTY' },
          //   { text: 'Sell Rate', value: 'SRATE' },
          //   { text: 'Sell Amount', value: 'SAMT' },
          //   { text: 'Close price', value: 'Close' },
          //   { text: 'Current Value', value: 'Curr_Value' },
          //   // { text: 'Notional P&l', value: 'NETAMT' },
          //   // { text: '', value: 'data-table-expand' },
          // ]
          // pushToDessertsExpand(axiosthis.dessertsexpand, response, 'ASSETS', 'Assets');
          // // pushToDessertsExpand(axiosthis.dessertsexpand, response, 'short_term', 'Short Term');
          // // pushToDessertsExpand(axiosthis.dessertsexpand, response, 'Liabilities', 'Liabilities');
          // // pushToDessertsExpand(axiosthis.dessertsexpand, response, 'trading', 'Trading');
          // console.log(axiosthis.dessertsexpand, 'fdfdfd');


          // for (let p = 0; p < axiosthis.dessertsexpand.length; p++) {
          //   if (axiosthis.dessertsexpand[p].name == 'Assets') {
          //     axiosthis.dessertsexpand[p]['header'] = headassert;
          //   }
          // }
          // for (let p = 0; p < axiosthis.dessertsexpand.length; p++) {
          //   if (axiosthis.dessertsexpand[p].name == 'Short Term') {
          //     axiosthis.dessertsexpand[p]['header'] = headshort;
          //   }
          // }
          // for (let p = 0; p < axiosthis.dessertsexpand.length; p++) {
          //   if (axiosthis.dessertsexpand[p].name == 'Liabilities') {
          //     axiosthis.dessertsexpand[p]['header'] = headliab;
          //   }
          // }
          // console.log(axiosthis.dessertsexpand);
          // .........................................................................
          // let headfutclose = [
          //   {
          //     text: 'Symbol',
          //     align: 'start',
          //     sortable: false,
          //     value: 'SCRIP_SYMBOL',
          //   },
          //   // { text: 'Open Qty', value: 'NETQTY' },
          //   // { text: 'Open Rate', value: 'NRATE' },
          //   { text: 'Net Amount', value: 'NETAMT' },
          //   { text: 'Buy Qty', value: 'BQTY' },
          //   { text: 'Buy Rate', value: 'BRATE' },
          //   { text: 'Buy Amount', value: 'BAMT' },

          //   { text: 'Sell Qty', value: 'SQTY' },
          //   { text: 'Sell Rate', value: 'SRATE' },
          //   { text: 'Sell Amount', value: 'SAMT' },
          //   // { text: 'Close price', value: 'Close' },
          //   // { text: 'Current Value', value: 'Curr_Value' },
          //   { text: 'Notional P&l', value: 'NETAMT' },
          //   // { text: '', value: 'data-table-expand' },
          // ]
          // let headfutopen = [
          //   {
          //     text: 'Symbol',
          //     align: 'start',
          //     sortable: false,
          //     value: 'SCRIP_SYMBOL',
          //   },
          //   { text: 'Net Amount', value: 'NETAMT' },

          //   { text: 'Open Qty', value: 'NETQTY' },
          //   { text: 'Open Rate', value: 'NRATE' },
          //   { text: 'Buy Qty', value: 'BQTY' },
          //   { text: 'Buy Rate', value: 'BRATE' },
          //   { text: 'Buy Amount', value: 'BAMT' },

          //   { text: 'Sell Qty', value: 'SQTY' },
          //   { text: 'Sell Rate', value: 'SRATE' },
          //   { text: 'Sell Amount', value: 'SAMT' },
          //   { text: 'Close price', value: 'Close' },
          //   { text: 'Current Value', value: 'Curr_Value' },
          //   { text: 'Notional P&l', value: 'NETAMT' },
          //   // { text: '', value: 'data-table-expand' },
          // ]
          // axiosthis.dessertsexpandderivative = [];

          // function pushToDessertsExpandDerivative(array, response, category, name) {
          //   const data = response.data.Derivatives[category];
          //   if (data.length > 0) {
          //     array.push({ name, val: data });
          //   }
          // }
          // pushToDessertsExpandDerivative(axiosthis.dessertsexpandderivative, response, 'der_Fut_booked', 'Future Closed');
          // pushToDessertsExpandDerivative(axiosthis.dessertsexpandderivative, response, 'der_Fut_open', 'Future Open');
          // pushToDessertsExpandDerivative(axiosthis.dessertsexpandderivative, response, 'der_Opt_booked', 'Option Closed');
          // pushToDessertsExpandDerivative(axiosthis.dessertsexpandderivative, response, 'der_Opt_open', 'Option Open');

          // for (let p = 0; p < axiosthis.dessertsexpandderivative.length; p++) {
          //   if (axiosthis.dessertsexpandderivative[p].name == 'Future Closed' || axiosthis.dessertsexpandderivative[p].name == 'Option Closed') {
          //     axiosthis.dessertsexpandderivative[p]['header'] = headfutclose;
          //   }
          // }
          // for (let p = 0; p < axiosthis.dessertsexpandderivative.length; p++) {
          //   if (axiosthis.dessertsexpandderivative[p].name == 'Future Open' || axiosthis.dessertsexpandderivative[p].name == 'Option Open') {
          //     axiosthis.dessertsexpandderivative[p]['header'] = headfutopen;
          //   }
          // }

          // console.log(axiosthis.dessertsexpandderivative);

          // ........................................................................................
          // function pushToDessertsExpandcommodity(array, response, category, name) {
          //   const data = response.data.Commodity[category];
          //   if (data.length > 0) {
          //     array.push({ name, val: data });
          //   }
          // }
          // axiosthis.dessertsexpandcommodity = []
          // pushToDessertsExpandcommodity(axiosthis.dessertsexpandcommodity, response, 'com_booked', 'Commodity Closed');
          // pushToDessertsExpandcommodity(axiosthis.dessertsexpandcommodity, response, 'der_open', 'Commodity Open');
          // console.log(axiosthis.dessertsexpandcommodity);

          // function pushToDessertsExpandcurrency(array, response, category, name) {
          //   const data = response.data.Currency[category];
          //   if (data.length > 0) {
          //     array.push({ name, val: data });
          //   }
          // }
          // axiosthis.dessertsexpandcurrency = []
          // pushToDessertsExpandcurrency(axiosthis.dessertsexpandcurrency, response, 'curr_booked', 'Currency Closed');
          // pushToDessertsExpandcurrency(axiosthis.dessertsexpandcurrency, response, 'curr_open', 'Currency Open');
          // console.log(axiosthis.dessertsexpandcurrency);





          // axiosthis.loader = false

        })
        .catch((error) => {
          console.log(error);
        });

    },
    derivativesdat() {
      // this.eqloader = true
      this.disabletabsexpense = true
      this.disabletabs = true
      const axios = require('axios');
      let data = JSON.stringify({
        // "cc": "ZTN21H37"
        "cc": this.actid,
        'from': this.fromdateapi,
        'to': this.toshow
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'http://192.168.5.138:9003/getderpnl',
        url: `${apiurl}/getderpnl`,

        headers: {
          'Content-Type': 'application/json',
          'clientid': this.actid,
          'Authorization': this.susertoken
        },
        data: data
      };
      let axiosthis = this

      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          // console.log(axiosthis);
          if (response.data.msg != 'No Data Available') {
            var headerForPdf = ['Symbol', 'Buy Qty', 'Buy Rate', 'Sell Qty', 'Sell Rate', 'Net Qty', 'Net Rate', 'Close price', 'P&L']

            axiosthis.disabletabs = false
            axiosthis.disdowbtn = false
            axiosthis.chararr = response.data.Charges
            axiosthis.newstat = response.data.details

            var resdata = response.data
            const charges = response.data.Charges
            if (charges && charges.der_charges) {
              var dercharge = charges.der_charges
            }
            if (charges && charges.comm_charges) {
              var comcharge = charges.comm_charges
            }
            if (charges && charges.cur_charges) {
              var curcharge = charges.cur_charges
            }
            if (dercharge.length != 0) {
              for (let i = 0; i < dercharge.length; i++) {
                axiosthis.derchargers = dercharge.reduce((sum, item) => sum + Number(item.NETAMT), 0);
              }
              // axiosthis.derchargers = val
            } else {
              axiosthis.derchargers = 0

            }
            if (comcharge.length != 0) {
              for (let i = 0; i < comcharge.length; i++) {
                axiosthis.comchargers = comcharge.reduce((sum, item) => sum + Number(item.NETAMT), 0);
              }
              // axiosthis.comchargers = val
            } else {
              axiosthis.comchargers = 0

            }
            if (curcharge.length != 0) {
              for (let i = 0; i < curcharge.length; i++) {
                axiosthis.curchargers = curcharge.reduce((sum, item) => sum + Number(item.NETAMT), 0);
              }
              // axiosthis.curchargers = val
            } else {
              axiosthis.curchargers = 0

            }
            // console.log("test4", axiosthis.derchargers, axiosthis.comchargers, axiosthis.curchargers);




            // console.log(resdata.Derivatives.der_Fut_booked, "resdata");

            const derclose = resdata.Derivatives.der_Fut_booked
            const futopen = resdata.Derivatives.der_Fut_open
            const optclose = resdata.Derivatives.der_Opt_booked
            const optopen = resdata.Derivatives.der_Opt_open
            const categories = ['der_Fut_booked', 'der_Fut_open', 'der_Opt_booked', 'der_Opt_open'];


            categories.forEach(category => {
              const data = resdata.Derivatives[category] || [];
              axiosthis.downloadarray.push(...data);
            });
            // console.log("turnover", axiosthis.downloadarray);

            axiosthis.dessertsexpandderivative = []
            if (derclose.length != 0) {
              // console.log("turnover", derclose);
              axiosthis.tables.push({ heading: 'Derivative Future Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = derclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Derivative Future Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandderivative.push({ name: 'Future Closed', val: derclose })
              const derclosed = derclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const derclosedbuy = derclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const derclosedsel = derclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              axiosthis.derclsed = derclosed
              var deummyturnoverfut = derclosedbuy + derclosedsel
              // console.log("turnoverif", axiosthis.derclsed);

            } else {
              axiosthis.derclsed = 0
              deummyturnoverfut = 0
              // console.log("turnoverelse", axiosthis.derclsed);

              // deummyturnoverfut = 0
            }
            if (futopen.length != 0) {
              axiosthis.tables.push({ heading: 'Derivative Future Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = futopen.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Derivative Future Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              // console.log("turnoverif", futopen);
              axiosthis.dessertsexpandderivative.push({ name: 'Future Open', val: futopen })
              const futopend = futopen.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const futopendbuy = futopen.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const futopensel = futopen.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              const dummysel = futopensel + futopendbuy
              axiosthis.futopened = futopend + axiosthis.derclsed
              axiosthis.futurnover = deummyturnoverfut + dummysel
              // console.log("turnover", axiosthis.futopened);
              // console.log("Sum of NETAMT values:", futopend);
            } else {
              axiosthis.futopened = 0 + axiosthis.derclsed
              axiosthis.futurnover = 0 + deummyturnoverfut
              // axiosthis.futurnover = 0
              // console.log("turnoverelse", axiosthis.futurnover);

            }
            if (optclose.length != 0) {
              // console.log("turnover", optclose);
              axiosthis.tables.push({ heading: 'Derivative Option Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = optclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Derivative Option Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandderivative.push({ name: 'Option Closed', val: optclose })
              const opcld = optclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const opoclsdbuy = optclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const opclssel = optclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              var dummy = opoclsdbuy + opclssel
              axiosthis.optioncls = opcld
              // console.log("turnoverif", axiosthis.optioncls);

              // console.log("Sum of NETAMT values:", opcld);
            } else {
              axiosthis.optioncls = 0
              // console.log("turnoverelse", axiosthis.optioncls);
              dummy = 0
              // dummy = 0
            }
            if (optopen.length != 0) {
              axiosthis.tables.push({ heading: 'Derivative Option Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = optopen.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Derivative Option Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandderivative.push({ name: 'Option Open', val: optopen })
              // console.log("turnover", optopen);

              const opopn = optopen.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const opopendbuy = optopen.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const opopensel = optopen.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              const dummy2 = opopendbuy + opopensel
              axiosthis.opturnover = dummy2 + dummy
              axiosthis.optionopn = opopn + axiosthis.optioncls
              // console.log("turnoverif", axiosthis.optionopn);

              // console.log("Sum of NETAMT values:", opopn);
            } else {
              axiosthis.optionopn = 0 + axiosthis.optioncls
              // console.log("turnoverelse", axiosthis.optionopn);
              axiosthis.opturnover = 0 + dummy
              // axiosthis.opturnover = 0
            }

            // ...........................................................................................................................



            axiosthis.dessertsexpandcommodity = []
            const comfutop = resdata.Commodity.com_fut_open
            const comfuclose = resdata.Commodity.com_fut_booked
            const comclose = resdata.Commodity.com_opt_booked
            const compen = resdata.Commodity.com_opt_open
            const categories1 = ['com_fut_open', 'com_fut_booked', 'com_opt_booked', 'com_opt_open'];


            categories1.forEach(category => {
              const data = resdata.Commodity[category] || [];
              axiosthis.downloadarray.push(...data);
            });
            // console.log("turnover 2",axiosthis.downloadarray)

            if (comfuclose.length != 0) {
              axiosthis.tables.push({ heading: 'Commodity Future  Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = comfuclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Commodity Future  Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcommodity.push({ name: 'Future  Closed', val: comfuclose })
              const comnetAmtSum = comfuclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comclosedbuy = comfuclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comclosesel = comfuclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              var dummycomfut = comclosedbuy + comclosesel
              axiosthis.comnetfutamt = comnetAmtSum
            } else {
              axiosthis.comnetfutamt = 0
              dummycomfut = 0
            }

            if (comfutop.length != 0) {
              axiosthis.tables.push({ heading: 'Commodity Future  Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = comfutop.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Commodity Future  Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcommodity.push({ name: 'Future  Open', val: comfutop })
              const comnetAmfuttSum = comfutop.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comptfutdbuy = comfutop.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comopfutsel = comfutop.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              axiosthis.comnetfutamt = comnetAmfuttSum + axiosthis.comnetfutamt
              const dummyturn = comptfutdbuy + comopfutsel
              axiosthis.futturnover = dummycomfut + dummyturn
            } else {
              axiosthis.comnetfutamt = 0 + axiosthis.comnetfutamt
              axiosthis.futturnover = dummycomfut
            }

            if (comclose.length != 0) {
              axiosthis.tables.push({ heading: 'Commodity Option Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = comclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Commodity Option Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcommodity.push({ name: 'Option Closed', val: comclose })
              const comnetAmtSum = comclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comclosedbuy = comclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comclosesel = comclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              var dummycom = comclosedbuy + comclosesel
              axiosthis.comnetamt = comnetAmtSum
            } else {
              axiosthis.comnetamt = 0
              dummycom = 0
            }

            if (compen.length != 0) {
              axiosthis.tables.push({ heading: 'Commodity Option Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = compen.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Commodity Option Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcommodity.push({ name: 'Option Open', val: compen })
              const comopnetAmtSum = compen.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comopdbuy = compen.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comopsel = compen.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              const ttval = comopdbuy + comopsel + dummycom
              axiosthis.comturnover = ttval
              axiosthis.comnetamt = comopnetAmtSum + axiosthis.comnetamt
            } else {
              axiosthis.comnetamt = 0 + axiosthis.comnetamt
              axiosthis.comturnover = dummycom
            }
            // console.log("test", axiosthis.comnetamt, axiosthis.comturnover, axiosthis.futturnover, axiosthis.comnetfutamt);






            axiosthis.dessertsexpandcurrency = []
            const curfutclose = resdata.Currency.curr_fut_booked
            const curfutopen = resdata.Currency.curr_fut_open
            const curopclose = resdata.Currency.curr_opt_booked
            const curopopen = resdata.Currency.curr_opt_open
            const categories2 = ['curr_fut_booked', 'curr_fut_open', 'curr_opt_booked', 'curr_opt_open'];


            categories2.forEach(category => {
              const data = resdata.Commodity[category] || [];
              axiosthis.downloadarray.push(...data);
            });
            // console.log("turnover 3",axiosthis.downloadarray)


            if (curfutclose.length != 0) {
              axiosthis.tables.push({ heading: 'Currency Future  Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = curfutclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Currency Future  Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcurrency.push({ name: 'Future  Closed', val: curfutclose })
              const comnetAmtSum = curfutclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comclosedbuy = curfutclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comclosesel = curfutclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              var dummycurfut = comclosedbuy + comclosesel
              axiosthis.curnetfutamt = comnetAmtSum
            } else {
              axiosthis.curnetfutamt = 0
              dummycurfut = 0
            }

            if (curfutopen.length != 0) {
              axiosthis.tables.push({ heading: 'Currency Future  Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = curfutopen.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Currency Future  Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcurrency.push({ name: 'Future  Open', val: curfutopen })
              const comnetAmfuttSum = curfutopen.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comptfutdbuy = curfutopen.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comopfutsel = curfutopen.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              axiosthis.curnetfutamt = comnetAmfuttSum + axiosthis.curnetfutamt
              const dummyturn = comptfutdbuy + comopfutsel
              axiosthis.curfutturnover = dummycurfut + dummyturn
            } else {
              axiosthis.curnetfutamt = 0 + axiosthis.curnetfutamt
              axiosthis.curfutturnover = dummycurfut
            }

            if (curopclose.length != 0) {
              axiosthis.tables.push({ heading: 'Currency Option Closed', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = curopclose.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Currency Option Closed');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcurrency.push({ name: 'Option Closed', val: curopclose })
              const comnetAmtSum = curopclose.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comclosedbuy = curopclose.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comclosesel = curopclose.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              var dummycur = comclosedbuy + comclosesel
              axiosthis.curopnetamt = comnetAmtSum
            } else {
              axiosthis.curopnetamt = 0
              dummycur = 0
            }

            if (curopopen.length != 0) {
              axiosthis.tables.push({ heading: 'Currency Option Open', data: [] });

              // Prepare the data for 'Assets'
              const assetsData = curopopen.map(item => [

                item.SCRIP_NAMEDATA || item.SCRIP_SYMBOL,
                item.BUY_QTY || item.BUYQTY,
                item.BUY_RATE || item.BUYRATE,
                item.SALE_QTY || item.SALEQTY,
                item.SALE_RATE || item.SALERATE,
                item.NET_QTY || item.NETQTY,
                item.NET_RATE || item.NETRATE,
                item.Closing_Price || item.CL_PRICE,
                item.NOTIONAL_NET
              ]);

              // Add header and assets data to the 'Assets' table
              const assetsTable = axiosthis.tables.find(table => table.heading === 'Currency Option Open');
              if (assetsTable) {
                // Remove any existing instances of headerForPdf


                // Add the header and assets data
                assetsTable.data.unshift(headerForPdf);
                assetsTable.data.push(...assetsData);
              }
              axiosthis.dessertsexpandcurrency.push({ name: 'Option Open', val: curopopen })
              const comopnetAmtSum = curopopen.reduce((sum, item) => sum + Number(item.NOTIONAL_NET), 0);
              const comopdbuy = curopopen.reduce((sum, item) => sum + Number(item.BUYAMT), 0);
              const comopsel = curopopen.reduce((sum, item) => sum + Number(item.SALEAMT), 0);
              const ttval = comopdbuy + comopsel + dummycur
              axiosthis.comopturnover = ttval
              axiosthis.curopnetamt = comopnetAmtSum + axiosthis.curopnetamt
            } else {
              axiosthis.curopnetamt = 0 + axiosthis.curopnetamt
              axiosthis.comopturnover = dummycur
            }
          } else {
            axiosthis.disabletabs = false
            axiosthis.disdowbtn = false
          }


          // console.log(response.data.msg == 'No Data Available',response.data.msg);
          // if(response.data.msg == 'No Data Available'){

          //   // alert("fghjk")
          // }

          // if (curclose.length != 0) {
          //   axiosthis.dessertsexpandcurrency.push({ name: 'Currency Closed', val: curclose })
          // }
          // if (curopen.length != 0) {
          //   axiosthis.dessertsexpandcurrency.push({ name: 'Currency Open', val: curopen })
          // }
          // console.log("test2", axiosthis.curnetfutamt, axiosthis.curfutturnover, axiosthis.curopnetamt, axiosthis.comopturnover);
          axiosthis.downloadarrayForPdf = axiosthis.tables

        })
        .catch((error) => {
          console.log(error);
        });
    },
    gettaxpnl(yearis) {
      this.loader = true

      // var todayapi = dd + '/' + mm + '/' + yyyy;
      this.dessertsexpand = []
      this.dessertsexpandderivative = []
      this.dessertsexpandcommodity = []
      this.dessertsexpandcurrencys = []
      this.tradenetamt = 0
      this.totalintraday = 0
      this.longnetval = 0
      this.stnetamt = 0
      this.assnetamt = 0
      this.futopened = 0
      this.futurnover = 0
      this.optionopn = 0
      this.opturnover = 0
      this.comnetfutamt = 0
      this.futturnover = 0
      this.comnetamt = 0
      this.comturnover = 0
      this.tabvaluestack = 'Equities'
      this.tab = this.tab2
      // this.futturnover = 0
      // this.futturnover = 0
      // this.futturnover = 0
      // this.futturnover = 0
      // var year = yearis
      var today = new Date();
      // var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      if (mm < 3 && yyyy == yearis) {
        var yearmount = yearis - 1
      } else {
        yearmount = yearis
      }
      let yearnext = yearmount + 1
      var fromapi = '01' + '/' + '04' + '/' + yearmount;
      var today1 = '31' + '/' + '03' + '/' + yearnext;
      this.toshow = today1
      this.fromshow = fromapi
      this.fromdateapi = fromapi

      // this.fromshow = (this.fromshow) + '-' + (this.toshow)
      // this.toshow = today1
      // this.fromshow = this.fromshow + '-' + this.toshow
      this.equitiesdata()
      this.derivativesdat()
      this.expenseforequity()
    },
    expenseforequity() {
      this.segloader = true
      this.segval = 0
      const axios = require('axios');
      let data = JSON.stringify({
        "cc": this.actid,
        "from": this.fromdateapi,
        "to": this.toshow,
        "seg": "eq"
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'http://192.168.5.198:5050/getexpenses',
        url: `${apiurl}/getexpenseseperate`,

        headers: {
          'Content-Type': 'application/json',
          'clientid': this.actid,
          'Authorization': this.susertoken
        },
        data: data
      };
      let axiosthis = this
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (response.data.msg != 'No Data Available') {
            axiosthis.segloader = false
            //  alert("ghjkl")
            axiosthis.disabletabsexpense = false
            axiosthis.downbtn = false

            axiosthis.eqarr = response.data.eq

            // console.log(JSON.stringify(response.data));
            axiosthis.segval = response.data.Total
          } else {
            axiosthis.downbtn = true
            axiosthis.eqarr = []
            axiosthis.segloader = false
            axiosthis.disabletabsexpense = false
          }

          // console.log(axiosthis.segval);
        })
        .catch((error) => {
          console.log(error);
        });

    }

  },
  mounted() {

    this.susertoken = localStorage.getItem("usession");
    this.actid = localStorage.getItem("userid");
    this.cname = localStorage.getItem("cname");
    var res = this.decryptionFunction(localStorage.getItem("profile_data"));
    // console.log('ttttt',JSON.parse(res));
    var resp = JSON.parse(res);
    this.profiledetails = resp.client_data;
    this.loader = true

    var today = new Date();
    // var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    // var nextyear = yyyy + 1
    // var startYear = yyyy - 4;
    this.yearis = yyyy
    // for (let year = startYear; year <= yyyy; year++) {
    //   this.items.push(year);
    // }
    // var today = new Date();
    // var yyyy = today.getFullYear();

    if (mm < 4) {
      var yearmount = yyyy - 1
    } else {
      yearmount = yyyy
    }
    var startYear = yearmount - 4;
    this.yearis = yearmount;

    for (let year = yearmount; year >= startYear; year--) {
      this.items.push(year);
    }
    // var todayapi = dd + '/' + mm + '/' + yyyy;
    var fromapi = '01' + '/' + '04' + '/' + yearmount;
    let nextyear = parseInt(yearmount) + 1

    var today1 = '31' + '/' + '03' + '/' + nextyear;
    this.toshow = today1
    this.fromshow = fromapi
    this.fromdateapi = fromapi

    this.fromshow = (this.fromshow) + '-' + (this.toshow)
    // this.toshow = today1
    // this.fromshow = this.fromshow + '-' + this.toshow
    this.equitiesdata()
    this.derivativesdat()
    this.expenseforequity()
    // const axios = require('axios');
    this.convertImageToBase64();
    




  }
};
</script>

<style lang="scss">
.basil {
  background-color: #ffffff !important;
}

.basil--text {
  color: #020202 !important;
}

.v-tab {
  text-transform: none !important;
}

.v-tabs--grow>.v-tabs-bar .v-tab {
  /* flex: 1 0 auto; */
  max-width: none !important;
}

.itemRowBackground {
  background-color: orange;
}

.customRowClass {
  background-color: red !important;
}

.cust-table .v-data-table__wrapper tr,
.cust-table tr.v-data-table__expanded.v-data-table__expanded__row {
  background-color: rgb(238, 238, 255) !important;
  color: rgb(62, 62, 62) !important;
  font-weight: 500;

}

.cust-table .v-data-table__wrapper tr tr {
  background-color: #fff !important;
  color: rgb(0, 0, 0) !important;

}

.cust-table .theme--light.v-table tr {
  background-color: none !important;

}

.v-data-table__empty-wrapper td {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.brdr{
  border: 1px solid black;
}
.textbox{
  
}

/* Merged styles */

// .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
// .cust-table {
//     font-size: 0.875rem;
//     height: 36px;
// }</style>
